import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Avatar,
  Button,
  Card,
  CardContent,
  Chip,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Stack,
  TableCell,
  Typography,
  useMediaQuery,
} from '@mui/material';
import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import BadgeButton, { getColor } from './components/BadgeButton';
import React, { useState } from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PhoneIcon from '@mui/icons-material/Phone';
import MailIcon from '@mui/icons-material/Mail';
import { Box, margin } from '@mui/system';
import Dp from 'assets/dummy/buy.jpg';
import { poppins400, poppins500 } from 'theme/common.style';
import {
  displayFlex,
  imageCont,
  userDetCont,
} from 'component/ActivityContainer/ActivityContainer.style';
import TableDropdown from './components/TableDropdown';
import { useTheme } from '@emotion/react';
import VendorSelectMenu from './VendorSelectMenu';
import SelectMenu from './components/Actionbtn';
import { WarningLite } from './components/WarningLite';
import { styled } from '@mui/material/styles';
import { Contact, OfferContainer } from './BuyerRegistration.util';
import ManageOffer from './ManageOffer';

const DepositIconColor = () => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="5" fill="#6C2AD2" fill-opacity="0.1" />
      <path
        d="M14.8464 23.6927C17.1926 23.6927 19.4427 22.7607 21.1017 21.1017C22.7607 19.4427 23.6927 17.1926 23.6927 14.8464C23.6927 12.5002 22.7607 10.2501 21.1017 8.59104C19.4427 6.93203 17.1926 6 14.8464 6C12.5002 6 10.2501 6.93203 8.59104 8.59104C6.93203 10.2501 6 12.5002 6 14.8464C6 17.1926 6.93203 19.4427 8.59104 21.1017C10.2501 22.7607 12.5002 23.6927 14.8464 23.6927Z"
        fill="#6C2AD2"
        fill-opacity="0.1"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1479 8.21161V21.4812"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.1638 10.6242H13.6401C13.0802 10.6242 12.5432 10.8467 12.1473 11.2426C11.7514 11.6385 11.529 12.1754 11.529 12.7353C11.529 13.2952 11.7514 13.8322 12.1473 14.2281C12.5432 14.624 13.0802 14.8464 13.6401 14.8464H16.6559C17.2158 14.8464 17.7527 15.0688 18.1486 15.4647C18.5445 15.8606 18.7669 16.3975 18.7669 16.9574C18.7669 17.5173 18.5445 18.0543 18.1486 18.4502C17.7527 18.8461 17.2158 19.0685 16.6559 19.0685H11.529"
        fill="#6C2AD2"
        fill-opacity="0.1"
      />
      <path
        d="M18.1638 10.6242H13.6401C13.0802 10.6242 12.5432 10.8467 12.1473 11.2426C11.7514 11.6385 11.529 12.1754 11.529 12.7353C11.529 13.2952 11.7514 13.8322 12.1473 14.2281C12.5432 14.624 13.0802 14.8464 13.6401 14.8464H16.6559C17.2158 14.8464 17.7527 15.0688 18.1486 15.4647C18.5445 15.8606 18.7669 16.3975 18.7669 16.9574C18.7669 17.5173 18.5445 18.0543 18.1486 18.4502C17.7527 18.8461 17.2158 19.0685 16.6559 19.0685H11.529"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const SignContractColor = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="5" fill="#6C2AD2" fill-opacity="0.1" />
      <path
        d="M11.1291 12.6786C11.1291 12.3984 11.3159 12.2115 11.5961 12.2115H17.5742C17.8544 12.2115 18.0412 12.3984 18.0412 12.6786C18.0412 12.9588 17.8544 13.1456 17.5742 13.1456H11.5961C11.3626 13.1456 11.1291 12.9588 11.1291 12.6786ZM11.5961 15.9478H17.5742C17.8544 15.9478 18.0412 15.761 18.0412 15.4808C18.0412 15.2005 17.8544 15.0137 17.5742 15.0137H11.5961C11.3159 15.0137 11.1291 15.2005 11.1291 15.4808C11.1291 15.761 11.3626 15.9478 11.5961 15.9478ZM11.5961 18.7033H15.1456C15.4258 18.7033 15.6126 18.5165 15.6126 18.2363C15.6126 17.956 15.4258 17.7692 15.1456 17.7692H11.5961C11.3159 17.7692 11.1291 17.956 11.1291 18.2363C11.1291 18.4698 11.3626 18.7033 11.5961 18.7033ZM25 15.6676C25 15.9011 24.9066 16.1346 24.7198 16.3214L18.4615 22.4863C18.3681 22.5797 18.2747 22.6264 18.1813 22.6731L15.6593 23.7006C15.5659 23.7473 15.1456 23.8874 14.772 23.5137C14.5385 23.2802 14.445 22.9533 14.5852 22.6264L15.5659 20.1044C15.6126 20.011 15.6593 19.9176 15.7527 19.8242L20.2363 15.3874V9.73626H17.761C17.4808 9.73626 17.294 9.54945 17.294 9.26923V6.93406H9.54121C9.21429 6.93406 8.93407 7.21428 8.93407 7.5412V20.805C8.93407 21.1319 9.21429 21.4121 9.54121 21.4121H12.9973C13.2775 21.4121 13.4643 21.5989 13.4643 21.8791C13.4643 22.1593 13.2775 22.3462 12.9973 22.3462H9.54121C8.70055 22.3462 8 21.6456 8 20.805V7.5412C8 6.70055 8.70055 6 9.54121 6H17.761C17.9478 6 18.0412 6.09341 18.0879 6.14011L21.0302 8.9423C21.1703 9.08241 21.1703 9.26923 21.1703 9.26923V14.4533L22.011 13.6126C22.3846 13.239 22.9451 13.239 23.3187 13.6126L24.7198 15.0137C24.9066 15.2005 25 15.3874 25 15.6676ZM18.228 8.80219H19.5357L19.3022 8.56868L18.228 7.5412V8.80219ZM17.294 22.0192L16.2665 20.9451L15.5659 22.7198L17.294 22.0192ZM24.0659 15.6209L22.6648 14.2665L16.7802 20.1511L18.1346 21.5522L24.0659 15.6209Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
const UserNameDownArrow = () => {
  return (
    <svg
      width="10"
      height="5"
      viewBox="0 0 10 5"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.08761 0.246003C1.24588 0.0880873 1.49356 0.0737313 1.66809 0.202935L1.71809 0.246003L5.29036 3.81034L8.86264 0.246003C9.02092 0.0880873 9.26859 0.0737313 9.44312 0.202935L9.49312 0.246003C9.6514 0.40392 9.66578 0.651033 9.53629 0.825166L9.49312 0.875055L5.6056 4.75377C5.44733 4.91168 5.19966 4.92604 5.02513 4.79684L4.97512 4.75377L1.08761 0.875055C0.913506 0.701347 0.913506 0.419711 1.08761 0.246003Z"
        fill="black"
      />
    </svg>
  );
};

const SubjecttoContractIcon = () => {
  return (
    <svg
      width="23"
      height="34"
      viewBox="0 0 34 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M33.5 14.055C33.51 13.3989 33.3906 12.7472 33.1487 12.1372C32.9068 11.5272 32.547 10.9709 32.09 10.5L23.315 1.5C22.8437 1.02471 22.2829 0.647451 21.665 0.39C21.0471 0.132549 20.3844 0 19.715 0H5.525C4.19229 0 2.91416 0.529418 1.97179 1.47179C1.02942 2.41416 0.5 3.69229 0.5 5.025V39.975C0.5 41.3077 1.02942 42.5858 1.97179 43.5282C2.91416 44.4706 4.19229 45 5.525 45H28.475C29.1349 45 29.7883 44.87 30.398 44.6175C31.0076 44.365 31.5616 43.9948 32.0282 43.5282C32.4948 43.0616 32.865 42.5076 33.1175 41.898C33.37 41.2883 33.5 40.6349 33.5 39.975V14.055ZM28.49 11.175H23.855C23.7006 11.1881 23.5451 11.1696 23.3981 11.1206C23.2511 11.0716 23.1157 10.9931 23 10.89C22.789 10.6792 22.6703 10.3933 22.67 10.095V5.205L28.49 11.175ZM28.49 42H5.525C5.25852 42.002 4.9943 41.951 4.74771 41.8499C4.50112 41.7489 4.2771 41.5998 4.08866 41.4113C3.90022 41.2229 3.75114 40.9989 3.65008 40.7523C3.54902 40.5057 3.498 40.2415 3.5 39.975V5.025C3.498 4.75852 3.54902 4.4943 3.65008 4.24771C3.75114 4.00112 3.90022 3.7771 4.08866 3.58866C4.2771 3.40022 4.50112 3.25114 4.74771 3.15008C4.9943 3.04902 5.25852 2.998 5.525 3H19.7V10.095C19.7 10.638 19.8072 11.1756 20.0154 11.677C20.2237 12.1785 20.5289 12.6339 20.9135 13.0171C21.2981 13.4004 21.7546 13.7039 22.2568 13.9103C22.759 14.1167 23.297 14.222 23.84 14.22L30.5 14.145V39.975C30.502 40.2415 30.451 40.5057 30.3499 40.7523C30.2489 40.9989 30.0998 41.2229 29.9113 41.4113C29.7229 41.5998 29.4989 41.7489 29.2523 41.8499C29.0057 41.951 28.7415 42.002 28.475 42H28.49Z"
        fill="#6C2AD2"
      />
      <path
        d="M23 18.3594H11C10.6022 18.3594 10.2206 18.5174 9.93934 18.7987C9.65804 19.08 9.5 19.4616 9.5 19.8594C9.5 20.2572 9.65804 20.6387 9.93934 20.92C10.2206 21.2013 10.6022 21.3594 11 21.3594H23C23.3978 21.3594 23.7794 21.2013 24.0607 20.92C24.342 20.6387 24.5 20.2572 24.5 19.8594C24.5 19.4616 24.342 19.08 24.0607 18.7987C23.7794 18.5174 23.3978 18.3594 23 18.3594Z"
        fill="#6C2AD2"
      />
      <path
        d="M23 28.1543H11C10.6022 28.1543 10.2206 28.3123 9.93934 28.5936C9.65804 28.8749 9.5 29.2565 9.5 29.6543C9.5 30.0521 9.65804 30.4337 9.93934 30.715C10.2206 30.9963 10.6022 31.1543 11 31.1543H23C23.3978 31.1543 23.7794 30.9963 24.0607 30.715C24.342 30.4337 24.5 30.0521 24.5 29.6543C24.5 29.2565 24.342 28.8749 24.0607 28.5936C23.7794 28.3123 23.3978 28.1543 23 28.1543Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};

const SubjecttoDueDiligenceIconn = () => {
  return (
    <svg
      width="23"
      height="34"
      viewBox="0 0 33 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.1921 5.27344H25.1662C24.6422 3.73896 23.2314 2.63672 21.5768 2.63672H20.0901C19.5663 1.10206 18.1547 0 16.4999 0C14.8451 0 13.4335 1.10206 12.9097 2.63672H11.423C9.76836 2.63672 8.35758 3.73896 7.83364 5.27344H3.80767C1.70812 5.27344 0 7.04769 0 9.22852V41.0449C0 43.2258 1.70812 45 3.80767 45H29.1921C31.2917 45 32.9998 43.2258 32.9998 41.0449V9.22852C32.9998 7.04769 31.2917 5.27344 29.1921 5.27344ZM10.1538 6.5918C10.1538 5.86485 10.7232 5.27344 11.423 5.27344H13.9615C14.6624 5.27344 15.2307 4.68316 15.2307 3.95508C15.2307 3.22813 15.8001 2.63672 16.4999 2.63672C17.1997 2.63672 17.7691 3.22813 17.7691 3.95508C17.7691 4.68316 18.3374 5.27344 19.0383 5.27344H21.5768C22.2766 5.27344 22.846 5.86485 22.846 6.5918V7.91016H10.1538V6.5918ZM30.4614 41.0449C30.4614 41.7719 29.892 42.3633 29.1921 42.3633H3.80767C3.10782 42.3633 2.53845 41.7719 2.53845 41.0449V9.22852C2.53845 8.50157 3.10782 7.91016 3.80767 7.91016H7.61534V9.22852C7.61534 9.9566 8.18361 10.5469 8.88456 10.5469H24.1152C24.8162 10.5469 25.3845 9.9566 25.3845 9.22852V7.91016H29.1921C29.892 7.91016 30.4614 8.50157 30.4614 9.22852V41.0449Z"
        fill="#666666"
      />
      <path
        d="M14.8602 22.9721C14.3646 22.4572 13.5609 22.4572 13.0652 22.9721L8.88584 27.3133L7.24482 25.6087C6.74923 25.0939 5.94555 25.0939 5.44988 25.6087C4.95421 26.1236 4.95421 26.9583 5.44988 27.4731L7.98841 30.1099C8.23616 30.3674 8.561 30.496 8.88584 30.496C9.21067 30.496 9.53551 30.3674 9.78326 30.1099L14.8602 24.8365C15.3558 24.3216 15.3558 23.4869 14.8602 22.9721Z"
        fill="#666666"
      />
      <path
        d="M14.8602 13.7455C14.3646 13.2307 13.5609 13.2307 13.0652 13.7455L8.88584 18.0867L7.24482 16.3822C6.74923 15.8673 5.94555 15.8673 5.44988 16.3822C4.95421 16.897 4.95421 17.7317 5.44988 18.2466L7.98841 20.8834C8.23616 21.1408 8.561 21.2695 8.88584 21.2695C9.21067 21.2695 9.53551 21.1408 9.78326 20.8834L14.8602 15.6099C15.3558 15.0951 15.3558 14.2604 14.8602 13.7455Z"
        fill="#666666"
      />
      <path
        d="M14.8602 32.1967C14.3646 31.6818 13.5609 31.6818 13.0652 32.1967L8.88584 36.538L7.24482 34.8335C6.74923 34.3186 5.94555 34.3186 5.44988 34.8335C4.95421 35.3484 4.95421 36.1831 5.44988 36.6979L7.98841 39.3346C8.23616 39.5921 8.561 39.7207 8.88584 39.7207C9.21067 39.7207 9.53551 39.5921 9.78326 39.3346L14.8602 34.0611C15.3558 33.5463 15.3558 32.7116 14.8602 32.1967Z"
        fill="#666666"
      />
      <path
        d="M26.6541 15.9961H19.0388C18.3378 15.9961 17.7695 16.5864 17.7695 17.3145C17.7695 18.0425 18.3378 18.6328 19.0388 18.6328H26.6541C27.355 18.6328 27.9233 18.0425 27.9233 17.3145C27.9233 16.5864 27.355 15.9961 26.6541 15.9961Z"
        fill="#666666"
      />
      <path
        d="M26.6541 34.4492H19.0388C18.3378 34.4492 17.7695 35.0395 17.7695 35.7676C17.7695 36.4957 18.3378 37.0859 19.0388 37.0859H26.6541C27.355 37.0859 27.9233 36.4957 27.9233 35.7676C27.9233 35.0395 27.355 34.4492 26.6541 34.4492Z"
        fill="#666666"
      />
      <path
        d="M26.6541 25.2266H19.0388C18.3378 25.2266 17.7695 25.8168 17.7695 26.5449C17.7695 27.273 18.3378 27.8633 19.0388 27.8633H26.6541C27.355 27.8633 27.9233 27.273 27.9233 26.5449C27.9233 25.8168 27.355 25.2266 26.6541 25.2266Z"
        fill="#666666"
      />
    </svg>
  );
};

const SubjecttoFinanceIcon = () => {
  return (
    <svg
      width="40"
      height="34"
      viewBox="0 0 33 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {' '}
      <path
        d="M36.3437 3.60938C33.0335 3.60938 30.418 6.36856 30.418 9.80693C30.418 13.2453 33.0743 15.962 36.3437 15.962C39.613 15.962 42.3102 13.2029 42.3102 9.76448C42.3102 6.32611 39.6539 3.60938 36.3437 3.60938ZM36.3437 14.6037C33.7691 14.6037 31.6848 12.4388 31.6848 9.76448C31.6848 7.09019 33.8099 4.96774 36.3437 4.96774C38.9183 4.96774 41.0025 7.13264 41.0025 9.80693C41.0025 12.4812 38.9183 14.6037 36.3437 14.6037Z"
        fill="#666666"
      />
      <path
        d="M38.2233 10.743C38.1824 10.6156 38.1824 10.5307 38.1007 10.4033C38.0598 10.3184 38.0189 10.191 37.9372 10.1061C37.8554 10.0212 37.8146 9.93629 37.7328 9.85137C37.6511 9.76645 37.5693 9.68154 37.4467 9.63908C37.3649 9.55416 37.2423 9.5117 37.1605 9.46925C37.0379 9.42679 36.9562 9.34187 36.8335 9.29941C36.7109 9.25696 36.5883 9.2145 36.5065 9.17204C36.4657 9.17204 36.3839 9.12958 36.343 9.08712C36.3022 9.04467 36.2204 9.04466 36.1795 9.00221C36.1387 8.95975 36.0569 8.95975 36.016 8.91729C35.9752 8.87483 35.9343 8.83237 35.8934 8.78992C35.8525 8.74746 35.8116 8.705 35.8116 8.62008C35.7708 8.57763 35.7708 8.49271 35.7708 8.45025C35.7708 8.36534 35.7708 8.32288 35.7708 8.23796C35.7708 8.1955 35.8116 8.11059 35.8116 8.06813C35.8525 8.02567 35.8525 7.94075 35.8934 7.8983C35.9343 7.85584 35.9752 7.81338 36.016 7.77092C36.0569 7.72846 36.1387 7.68601 36.2204 7.68601C36.3022 7.64355 36.343 7.64355 36.4248 7.64355C36.4657 7.64355 36.5065 7.64355 36.5474 7.64355C36.5883 7.64355 36.6292 7.64355 36.67 7.64355C36.7518 7.64355 36.7927 7.64355 36.8744 7.68601C36.9562 7.68601 37.0379 7.72846 37.0788 7.72846C37.1197 7.72846 37.2014 7.77092 37.2423 7.77092C37.324 7.77092 37.3649 7.81338 37.4058 7.81338L37.6102 7.8983L37.6511 7.64355L37.7328 6.96422V6.79438L37.5693 6.75193C37.5284 6.75193 37.4467 6.70947 37.4058 6.70947C37.3649 6.70947 37.324 6.66701 37.2423 6.66701C37.2014 6.66701 37.1197 6.62455 37.0379 6.62455C36.9562 6.62455 36.9153 6.58209 36.8335 6.58209H36.7927V5.98768V5.77539H36.5883H36.016H35.8116V5.98768V6.62455H35.7708C35.6481 6.66701 35.5255 6.70947 35.4029 6.79438C35.2803 6.83684 35.1985 6.92176 35.1168 7.00668C35.035 7.09159 34.9533 7.17651 34.8715 7.30388C34.7898 7.3888 34.7489 7.51617 34.708 7.64355C34.6671 7.77092 34.6263 7.8983 34.5854 8.02567C34.5445 8.15304 34.5445 8.32288 34.5445 8.45025C34.5445 8.57763 34.5445 8.66254 34.5854 8.78992C34.6263 8.91729 34.6263 9.00221 34.708 9.12958C34.7489 9.2145 34.8306 9.34187 34.8715 9.42679C34.9533 9.5117 34.9941 9.59662 35.0759 9.68154C35.1576 9.76645 35.2394 9.85137 35.362 9.89383C35.4438 9.97874 35.5664 10.0212 35.6481 10.0637C35.7708 10.1061 35.8934 10.191 35.9751 10.2335C36.0978 10.2759 36.2204 10.3184 36.3022 10.3609C36.343 10.3609 36.4248 10.4033 36.4657 10.4458C36.5065 10.4882 36.5883 10.4882 36.6292 10.5307C36.67 10.5732 36.7109 10.6156 36.7518 10.6156C36.7927 10.6581 36.8335 10.7005 36.8744 10.743C36.9153 10.7854 36.9153 10.8279 36.9562 10.9128C36.9562 10.9553 36.997 11.0402 36.997 11.1251C36.997 11.21 36.997 11.2525 36.997 11.3374C36.997 11.3799 36.9562 11.4648 36.9153 11.5072C36.8744 11.5497 36.8335 11.5922 36.7927 11.6346C36.7518 11.6771 36.7109 11.7195 36.6292 11.762C36.5883 11.8044 36.5065 11.8044 36.4657 11.8469C36.4248 11.8469 36.343 11.8894 36.2613 11.8894C36.2204 11.8894 36.1795 11.8894 36.0978 11.8894C36.0569 11.8894 35.9751 11.8894 35.9343 11.8894C35.8525 11.8894 35.7708 11.8894 35.7299 11.8894C35.6481 11.8894 35.5664 11.8469 35.5255 11.8469C35.4438 11.8469 35.362 11.8044 35.2803 11.762C35.1985 11.7195 35.1168 11.7195 35.035 11.6771C34.9941 11.6771 34.9533 11.6346 34.9124 11.6346C34.8715 11.6346 34.8306 11.5922 34.7898 11.5922L34.5445 11.4648L34.5036 11.762L34.4219 12.5262V12.6536L34.5445 12.6961C34.708 12.6536 34.7898 12.6961 34.9124 12.7385C34.9941 12.781 35.1168 12.8234 35.1985 12.8234C35.2803 12.8659 35.4029 12.8659 35.5255 12.9084C35.6481 12.9508 35.7299 12.9508 35.8525 12.9508H35.9343V13.5877V13.8H36.1387H36.7109H36.9153V13.5877V12.9084H36.9562C37.0788 12.8659 37.2014 12.8234 37.324 12.7385C37.4467 12.6961 37.5284 12.6111 37.6511 12.5262C37.7328 12.4413 37.8146 12.3564 37.8963 12.229C37.9781 12.1441 38.0189 12.0167 38.1007 11.8894C38.1416 11.762 38.1824 11.6346 38.2233 11.5072C38.2642 11.3799 38.2642 11.2525 38.2642 11.0827C38.2642 10.9553 38.2642 10.8704 38.2233 10.743Z"
        fill="#666666"
      />
      <path
        d="M33.4817 16.7698C33.2773 16.4726 32.8278 16.4302 32.5417 16.6424L25.9213 22.1183L17.3801 18.4253C17.1758 18.3404 16.9306 18.3828 16.7671 18.5102L7.61291 25.302C7.32684 25.5143 7.24511 25.9388 7.44944 26.2359C7.57204 26.4481 7.77638 26.533 7.98071 26.533C8.10332 26.533 8.22592 26.4906 8.34852 26.4057L17.2166 19.8261L25.7987 23.5192C26.003 23.6041 26.2891 23.5616 26.4526 23.4343L33.3591 17.7461C33.6451 17.5338 33.686 17.0669 33.4817 16.7698Z"
        fill="#666666"
      />
      <path
        d="M43.0458 40.0323H40.0216V20.3784C40.0216 19.9964 39.7356 19.6992 39.3678 19.6992H33.3603C32.9925 19.6992 32.7064 19.9964 32.7064 20.3784V40.0323H30.4996V27.1702C30.4996 26.7882 30.2136 26.4911 29.8458 26.4911H23.7975C23.4297 26.4911 23.1436 26.7882 23.1436 27.1702V40.0323H20.9368V26.1515C20.9368 25.7694 20.6507 25.4723 20.2829 25.4723H14.2755C13.9077 25.4723 13.6216 25.7694 13.6216 26.1515V40.0323H11.4148V30.1417C11.4148 29.7596 11.1287 29.4625 10.7609 29.4625H4.7126C4.3448 29.4625 4.05873 29.7596 4.05873 30.1417V40.0323H0.993715C0.625912 40.0323 0.339844 40.3294 0.339844 40.7115C0.339844 41.0935 0.625912 41.3907 0.993715 41.3907H4.67174H10.6792H14.2755H20.2829H23.7975H29.8049H33.3195H39.3269H43.0049C43.3727 41.3907 43.6588 41.0935 43.6588 40.7115C43.6996 40.3294 43.4136 40.0323 43.0458 40.0323ZM10.0662 40.0323H5.36648V30.8209H10.0662V40.0323ZM19.629 40.0323H14.9293V26.8307H19.629V40.0323ZM29.151 40.0323H24.4513V27.8494H29.151V40.0323ZM38.7139 40.0323H34.0142V21.0576H38.7139V40.0323Z"
        fill="#666666"
      />
      <defs>
        <clipPath id="clip0_19865_111701">
          <rect
            width="43.3228"
            height="45"
            fill="white"
            transform="translate(0.339844)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

const SubjecttoSettlement = () => {
  return (
    <svg
      width="40"
      height="34"
      viewBox="0 0 34 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M37.3166 0H6.77058C5.06559 0.00186126 3.43095 0.70621 2.22534 1.95849C1.01973 3.21077 0.341636 4.9087 0.339844 6.67969L0.339844 12.041C0.339844 12.3907 0.473565 12.726 0.711591 12.9732C0.949616 13.2205 1.27245 13.3594 1.60907 13.3594H10.6629V43.6816C10.6629 44.0313 10.7966 44.3666 11.0346 44.6139C11.2726 44.8611 11.5955 45 11.9321 45H42.3934C42.7301 45 43.0529 44.8611 43.2909 44.6139C43.5289 44.3666 43.6627 44.0313 43.6627 43.6816V6.5918C43.6607 4.84419 42.9914 3.16875 41.8017 1.933C40.612 0.697256 38.999 0.00209337 37.3166 0V0ZM2.87829 10.7227V6.67969C2.87963 5.60785 3.29014 4.58032 4.0198 3.82242C4.74945 3.06452 5.73869 2.63811 6.77058 2.63672H10.6629V10.7227H2.87829ZM41.1242 42.3633H13.2013V2.63672H37.3166C38.3261 2.63788 39.2939 3.05495 40.0077 3.79642C40.7216 4.53789 41.1231 5.5432 41.1242 6.5918V42.3633Z"
        fill="#666666"
      />
      <path
        d="M29.2799 22.914H23.6437C23.3071 22.914 22.9842 23.0529 22.7462 23.3001C22.5082 23.5473 22.3745 23.8827 22.3745 24.2323C22.3745 24.582 22.5082 24.9173 22.7462 25.1645C22.9842 25.4118 23.3071 25.5507 23.6437 25.5507H25.8953V27.1582C25.8953 27.5079 26.029 27.8432 26.2671 28.0904C26.5051 28.3377 26.8279 28.4766 27.1645 28.4766C27.5011 28.4766 27.824 28.3377 28.062 28.0904C28.3 27.8432 28.4338 27.5079 28.4338 27.1582V25.5507H29.2799C29.9898 25.55 30.6705 25.2568 31.1725 24.7355C31.6746 24.2141 31.9571 23.5072 31.958 22.7698V18.3814C31.9571 17.644 31.6746 16.9371 31.1725 16.4158C30.6705 15.8945 29.9898 15.6013 29.2799 15.6006H25.0492C25.0123 15.6006 24.9769 15.5854 24.9507 15.5584C24.9246 15.5314 24.9098 15.4948 24.9095 15.4564V11.0681C24.9095 11.0491 24.9132 11.0302 24.9202 11.0127C24.9272 10.9952 24.9375 10.9792 24.9505 10.9658C24.9635 10.9524 24.9789 10.9418 24.9958 10.9346C25.0127 10.9275 25.0309 10.9238 25.0492 10.9239H30.682C31.0186 10.9239 31.3414 10.785 31.5794 10.5378C31.8175 10.2905 31.9512 9.95522 31.9512 9.60557C31.9512 9.25592 31.8175 8.92059 31.5794 8.67335C31.3414 8.42611 31.0186 8.28721 30.682 8.28721H28.4338V6.67969C28.4338 6.33004 28.3 5.99471 28.062 5.74747C27.824 5.50023 27.5011 5.36133 27.1645 5.36133C26.8279 5.36133 26.5051 5.50023 26.2671 5.74747C26.029 5.99471 25.8953 6.33004 25.8953 6.67969V8.28721H25.0492C24.3392 8.2879 23.6586 8.58108 23.1565 9.10242C22.6545 9.62376 22.372 10.3307 22.3711 11.0681V15.4564C22.372 16.1938 22.6545 16.9008 23.1565 17.4221C23.6586 17.9434 24.3392 18.2366 25.0492 18.2373H29.2799C29.3168 18.2373 29.3522 18.2525 29.3783 18.2795C29.4045 18.3065 29.4193 18.3431 29.4195 18.3814V22.7698C29.4195 22.7888 29.4159 22.8076 29.4089 22.8252C29.4018 22.8427 29.3915 22.8587 29.3786 22.8721C29.3656 22.8855 29.3502 22.8961 29.3333 22.9032C29.3163 22.9104 29.2982 22.9141 29.2799 22.914Z"
        fill="#666666"
      />
      <path
        d="M36.4704 33.9258H17.8552C17.5185 33.9258 17.1957 34.0647 16.9577 34.3119C16.7197 34.5592 16.5859 34.8945 16.5859 35.2441C16.5859 35.5938 16.7197 35.9291 16.9577 36.1764C17.1957 36.4236 17.5185 36.5625 17.8552 36.5625H36.4704C36.8071 36.5625 37.1299 36.4236 37.3679 36.1764C37.6059 35.9291 37.7397 35.5938 37.7397 35.2441C37.7397 34.8945 37.6059 34.5592 37.3679 34.3119C37.1299 34.0647 36.8071 33.9258 36.4704 33.9258Z"
        fill="#666666"
      />
    </svg>
  );
};
const LinkPartner = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="url(#paint0_linear_33347_145093)"
      />
      <path
        d="M10.0297 4.4698C10.0297 4.3452 10.0819 4.22571 10.1747 4.1376C10.2675 4.0495 10.3935 4 10.5248 4C10.8401 4 11.1495 4.06013 11.451 4.17477C11.7792 4.29926 12.0317 4.48389 12.2609 4.70094C12.4901 4.91893 12.6847 5.15852 12.8158 5.47C12.9366 5.75611 13 6.04973 13 6.34899C13 6.64826 12.9366 6.94188 12.8158 7.22799C12.6866 7.53571 12.495 7.77295 12.2693 7.98859L11.7822 8.49738C11.7769 8.50283 11.7714 8.50816 11.7658 8.51336L10.1817 10.0167C9.95248 10.2342 9.7 10.4189 9.37178 10.5438C9.07764 10.6577 8.7632 10.7168 8.44554 10.7181C8.12786 10.7167 7.81342 10.6573 7.51931 10.5434C7.19109 10.4189 6.93861 10.2342 6.70941 10.0172C6.4802 9.7992 6.28564 9.5596 6.15446 9.24812C6.02965 8.95392 5.96708 8.63928 5.9703 8.32215C5.9703 8.02289 6.03366 7.72926 6.15446 7.44315C6.28564 7.13168 6.4802 6.89208 6.70891 6.67456L7.25347 6.15779C7.29943 6.11414 7.354 6.07951 7.41407 6.05587C7.47413 6.03224 7.53851 6.02006 7.60354 6.02004C7.66856 6.02002 7.73295 6.03215 7.79304 6.05574C7.85312 6.07934 7.90772 6.11393 7.95371 6.15755C7.99971 6.20117 8.0362 6.25296 8.0611 6.30996C8.08601 6.36696 8.09884 6.42806 8.09886 6.48977C8.09889 6.55147 8.0861 6.61258 8.06124 6.6696C8.03638 6.72662 7.99992 6.77843 7.95396 6.82208L7.40941 7.33886C7.24257 7.49718 7.1401 7.63342 7.07376 7.79175C7.00039 7.95998 6.9619 8.14007 6.9604 8.32215C6.9604 8.54577 6.99851 8.72148 7.07376 8.89953C7.1401 9.05785 7.24257 9.19409 7.40941 9.35242C7.57624 9.51074 7.7198 9.60799 7.88663 9.67094C8.0802 9.7447 8.26584 9.77852 8.44554 9.77852C8.62525 9.77852 8.81089 9.7447 9.00446 9.67094C9.17129 9.60799 9.31485 9.51074 9.48168 9.35242L11.0574 7.85705L11.5446 7.34826C11.5499 7.3428 11.5553 7.33748 11.5609 7.33228C11.7277 7.17396 11.8302 7.03772 11.8965 6.8794C11.9743 6.6957 12.0099 6.51953 12.0099 6.34899C12.0099 6.17846 11.9743 6.00228 11.8965 5.81859C11.8302 5.66027 11.7277 5.52403 11.5609 5.3657C11.3941 5.20738 11.2505 5.11013 11.0837 5.04671C10.9063 4.97724 10.7166 4.94087 10.5248 4.9396C10.3935 4.9396 10.2675 4.8901 10.1747 4.802C10.0819 4.71389 10.0297 4.5944 10.0297 4.4698ZM7.60396 5.1745C7.42426 5.1745 7.23861 5.20832 7.04505 5.28161C6.87822 5.34503 6.73465 5.44228 6.56782 5.60107L4.94257 7.14295L4.45545 7.65175L4.43911 7.66772C4.27228 7.82604 4.1698 7.96228 4.10297 8.1206C4.02977 8.28888 3.99144 8.46896 3.9901 8.65101C3.9901 8.82154 4.02574 8.99772 4.10297 9.18141C4.1698 9.33973 4.27228 9.47597 4.4396 9.6343C4.60594 9.79262 4.7495 9.88987 4.91634 9.95329C5.1099 10.0266 5.29554 10.0604 5.47525 10.0604C5.60654 10.0604 5.73246 10.1099 5.8253 10.198C5.91814 10.2861 5.9703 10.4056 5.9703 10.5302C5.9703 10.6548 5.91814 10.7743 5.8253 10.8624C5.73246 10.9505 5.60654 11 5.47525 11C5.15759 10.9987 4.84315 10.9395 4.54901 10.8257C4.22079 10.7007 3.96832 10.5161 3.73911 10.2986C3.5099 10.0811 3.31535 9.84148 3.18416 9.53C3.06404 9.25089 3.00152 8.95249 3 8.65101C3 8.35175 3.06337 8.05812 3.18416 7.77201C3.31337 7.4643 3.50495 7.22705 3.73069 7.01141L4.21782 6.50262L4.23416 6.48664L5.86782 4.93631C6.09703 4.71879 6.3495 4.53416 6.67772 4.40966C6.97183 4.29567 7.28627 4.23634 7.60396 4.2349C7.91931 4.2349 8.22871 4.29503 8.5302 4.40966C8.85842 4.53416 9.11089 4.71879 9.3401 4.93584C9.56931 5.15383 9.76386 5.39342 9.89505 5.7049C10.0158 5.99101 10.0792 6.28463 10.0792 6.58389C10.0792 6.88315 10.0158 7.17678 9.89505 7.46289C9.76535 7.7706 9.57376 8.00879 9.34802 8.22396L8.8104 8.78067C8.72164 8.8725 8.59808 8.92711 8.4669 8.93248C8.33571 8.93786 8.20766 8.89356 8.11089 8.80933C8.01413 8.7251 7.95658 8.60784 7.95092 8.48335C7.94526 8.35886 7.99194 8.23733 8.08069 8.1455L8.62525 7.58174L8.6401 7.56718C8.80693 7.40886 8.90941 7.27262 8.97574 7.1143C9.05346 6.9306 9.08911 6.75443 9.08911 6.58389C9.08911 6.41336 9.05346 6.23718 8.97574 6.05349C8.90941 5.89517 8.80693 5.75893 8.6401 5.6006C8.47327 5.44228 8.3297 5.34503 8.16287 5.28161C7.98556 5.21214 7.79579 5.17577 7.60396 5.1745Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_33347_145093"
          x1="0"
          y1="8"
          x2="16"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2BC4F3" />
          <stop offset="0.5" stop-color="#00AEEE" />
          <stop offset="1" stop-color="#0095DA" />
        </linearGradient>
      </defs>
    </svg>
  );
};
const LegalIcon = ({ uniqueId }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z"
        fill="url(#paint0_linear_33347_145093)"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.46869 3.46875C8.46869 3.34443 8.41931 3.2252 8.3314 3.13729C8.24349 3.04939 8.12426 3 7.99994 3C7.87562 3 7.75639 3.04939 7.66849 3.13729C7.58058 3.2252 7.53119 3.34443 7.53119 3.46875V4.25H6.91619C6.72557 4.25 6.53869 4.3 6.37307 4.39375L5.56807 4.85438C5.54428 4.86798 5.51734 4.87509 5.48994 4.875H4.09369C3.96937 4.875 3.85014 4.92439 3.76224 5.01229C3.67433 5.1002 3.62494 5.21943 3.62494 5.34375C3.62494 5.46807 3.67433 5.5873 3.76224 5.67521C3.85014 5.76311 3.96937 5.8125 4.09369 5.8125H4.36119L3.04119 8.745C3.0022 8.83176 2.99053 8.92832 3.00772 9.02187C3.02491 9.11542 3.07016 9.20152 3.13744 9.26875V9.26937L3.13869 9.27062L3.13994 9.27187L3.14369 9.27563L3.15369 9.285L3.18182 9.31C3.31326 9.42017 3.45716 9.51456 3.61057 9.59125C4.00413 9.78313 4.43712 9.8803 4.87494 9.875C5.42494 9.875 5.84744 9.7375 6.13932 9.59125C6.29272 9.51456 6.43662 9.42016 6.56807 9.31L6.59619 9.285L6.60619 9.27563L6.60994 9.27187L6.61119 9.27062L6.61182 9.26937L6.28119 8.9375L6.61244 9.26875C6.67973 9.20152 6.72497 9.11542 6.74216 9.02187C6.75935 8.92832 6.74768 8.83176 6.70869 8.745L5.38869 5.8125H5.48994C5.68057 5.8125 5.86744 5.7625 6.03307 5.66875L6.83869 5.20812C6.86229 5.19462 6.889 5.18752 6.91619 5.1875H7.53119V11.125H5.96869C5.84437 11.125 5.72514 11.1744 5.63724 11.2623C5.54933 11.3502 5.49994 11.4694 5.49994 11.5938C5.49994 11.7181 5.54933 11.8373 5.63724 11.9252C5.72514 12.0131 5.84437 12.0625 5.96869 12.0625H10.0312C10.1555 12.0625 10.2747 12.0131 10.3626 11.9252C10.4506 11.8373 10.4999 11.7181 10.4999 11.5938C10.4999 11.4694 10.4506 11.3502 10.3626 11.2623C10.2747 11.1744 10.1555 11.125 10.0312 11.125H8.46869V5.1875H9.08369C9.11088 5.18752 9.13759 5.19462 9.16119 5.20812L9.96744 5.66812C10.1324 5.76312 10.3193 5.8125 10.5099 5.8125H10.6112L9.29119 8.745C9.2522 8.83176 9.24053 8.92832 9.25772 9.02187C9.27491 9.11542 9.32016 9.20152 9.38744 9.26875V9.26937L9.38869 9.27062L9.38994 9.27187L9.39369 9.27563L9.40369 9.285L9.43182 9.31C9.56327 9.42016 9.70717 9.51455 9.86057 9.59125C10.2541 9.78313 10.6871 9.8803 11.1249 9.875C11.6749 9.875 12.0974 9.7375 12.3893 9.59125C12.5427 9.51457 12.6866 9.42018 12.8181 9.31L12.8462 9.285L12.8524 9.27875L12.8562 9.27563L12.8599 9.27187L12.8612 9.27062L12.8618 9.26937L12.5312 8.9375L12.8624 9.26875C12.9297 9.20152 12.975 9.11542 12.9922 9.02187C13.0094 8.92832 12.9977 8.83176 12.9587 8.745L11.6393 5.8125H11.9062C12.0305 5.8125 12.1497 5.76311 12.2376 5.67521C12.3256 5.5873 12.3749 5.46807 12.3749 5.34375C12.3749 5.21943 12.3256 5.1002 12.2376 5.01229C12.1497 4.92439 12.0305 4.875 11.9062 4.875H10.5099C10.4828 4.87498 10.456 4.86788 10.4324 4.85438L9.62619 4.39437C9.46118 4.29998 9.27442 4.25022 9.08432 4.25H8.46869V3.46875ZM4.05932 8.76687C4.23744 8.85125 4.50807 8.9375 4.87494 8.9375C5.24182 8.9375 5.51244 8.85125 5.69057 8.76687L4.87494 6.95438L4.05932 8.76687ZM10.3093 8.76687C10.4874 8.85125 10.7581 8.9375 11.1249 8.9375C11.4918 8.9375 11.7624 8.85125 11.9406 8.76687L11.1249 6.95438L10.3093 8.76687Z"
        fill="white"
      />

      <defs>
        <linearGradient
          id="paint0_linear_33347_145093"
          x1="0"
          y1="8"
          x2="16"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2BC4F3" />
          <stop offset="0.5" stop-color="#00AEEE" />
          <stop offset="1" stop-color="#0095DA" />
        </linearGradient>
      </defs>
    </svg>
  );
};

const PlusIcon = () => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="32" height="32" rx="5" fill="#BCBBBC" fill-opacity="0.1" />
      <path
        d="M16 9.5C16.2155 9.5 16.4222 9.5856 16.5745 9.73798C16.7269 9.89035 16.8125 10.097 16.8125 10.3125V15.1875H21.6875C21.903 15.1875 22.1097 15.2731 22.262 15.4255C22.4144 15.5778 22.5 15.7845 22.5 16C22.5 16.2155 22.4144 16.4222 22.262 16.5745C22.1097 16.7269 21.903 16.8125 21.6875 16.8125H16.8125V21.6875C16.8125 21.903 16.7269 22.1097 16.5745 22.262C16.4222 22.4144 16.2155 22.5 16 22.5C15.7845 22.5 15.5778 22.4144 15.4255 22.262C15.2731 22.1097 15.1875 21.903 15.1875 21.6875V16.8125H10.3125C10.097 16.8125 9.89035 16.7269 9.73798 16.5745C9.5856 16.4222 9.5 16.2155 9.5 16C9.5 15.7845 9.5856 15.5778 9.73798 15.4255C9.89035 15.2731 10.097 15.1875 10.3125 15.1875H15.1875V10.3125C15.1875 10.097 15.2731 9.89035 15.4255 9.73798C15.5778 9.5856 15.7845 9.5 16 9.5Z"
        fill="#666666"
      />
    </svg>
  );
};
const SignContract = ({ color = '#666666' }) => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="5" fill={color} fillOpacity="0.1" />
      <path
        d="M11.1291 12.6786C11.1291 12.3984 11.3159 12.2115 11.5961 12.2115H17.5742C17.8544 12.2115 18.0412 12.3984 18.0412 12.6786C18.0412 12.9588 17.8544 13.1456 17.5742 13.1456H11.5961C11.3626 13.1456 11.1291 12.9588 11.1291 12.6786ZM11.5961 15.9478H17.5742C17.8544 15.9478 18.0412 15.761 18.0412 15.4808C18.0412 15.2005 17.8544 15.0137 17.5742 15.0137H11.5961C11.3159 15.0137 11.1291 15.2005 11.1291 15.4808C11.1291 15.761 11.3626 15.9478 11.5961 15.9478ZM11.5961 18.7033H15.1456C15.4258 18.7033 15.6126 18.5165 15.6126 18.2363C15.6126 17.956 15.4258 17.7692 15.1456 17.7692H11.5961C11.3159 17.7692 11.1291 17.956 11.1291 18.2363C11.1291 18.4698 11.3626 18.7033 11.5961 18.7033ZM25 15.6676C25 15.9011 24.9066 16.1346 24.7198 16.3214L18.4615 22.4863C18.3681 22.5797 18.2747 22.6264 18.1813 22.6731L15.6593 23.7006C15.5659 23.7473 15.1456 23.8874 14.772 23.5137C14.5385 23.2802 14.445 22.9533 14.5852 22.6264L15.5659 20.1044C15.6126 20.011 15.6593 19.9176 15.7527 19.8242L20.2363 15.3874V9.73626H17.761C17.4808 9.73626 17.294 9.54945 17.294 9.26923V6.93406H9.54121C9.21429 6.93406 8.93407 7.21428 8.93407 7.5412V20.805C8.93407 21.1319 9.21429 21.4121 9.54121 21.4121H12.9973C13.2775 21.4121 13.4643 21.5989 13.4643 21.8791C13.4643 22.1593 13.2775 22.3462 12.9973 22.3462H9.54121C8.70055 22.3462 8 21.6456 8 20.805V7.5412C8 6.70055 8.70055 6 9.54121 6H17.761C17.9478 6 18.0412 6.09341 18.0879 6.14011L21.0302 8.9423C21.1703 9.08241 21.1703 9.26923 21.1703 9.26923V14.4533L22.011 13.6126C22.3846 13.239 22.9451 13.239 23.3187 13.6126L24.7198 15.0137C24.9066 15.2005 25 15.3874 25 15.6676ZM18.228 8.80219H19.5357L19.3022 8.56868L18.228 7.5412V8.80219ZM17.294 22.0192L16.2665 20.9451L15.5659 22.7198L17.294 22.0192ZM24.0659 15.6209L22.6648 14.2665L16.7802 20.1511L18.1346 21.5522L24.0659 15.6209Z"
        fill={color}
      />
    </svg>
  );
};

const DepositIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="5" fill="black" fill-opacity="0.1" />
      <path
        d="M14.8464 23.6927C17.1926 23.6927 19.4427 22.7607 21.1017 21.1017C22.7607 19.4427 23.6927 17.1926 23.6927 14.8464C23.6927 12.5002 22.7607 10.2501 21.1017 8.59104C19.4427 6.93203 17.1926 6 14.8464 6C12.5002 6 10.2501 6.93203 8.59104 8.59104C6.93203 10.2501 6 12.5002 6 14.8464C6 17.1926 6.93203 19.4427 8.59104 21.1017C10.2501 22.7607 12.5002 23.6927 14.8464 23.6927Z"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.1479 8.21161V21.4812"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.1638 10.6242H13.6401C13.0802 10.6242 12.5432 10.8467 12.1473 11.2426C11.7514 11.6385 11.529 12.1754 11.529 12.7353C11.529 13.2952 11.7514 13.8322 12.1473 14.2281C12.5432 14.624 13.0802 14.8464 13.6401 14.8464H16.6559C17.2158 14.8464 17.7527 15.0688 18.1486 15.4647C18.5445 15.8606 18.7669 16.3975 18.7669 16.9574C18.7669 17.5173 18.5445 18.0543 18.1486 18.4502C17.7527 18.8461 17.2158 19.0685 16.6559 19.0685H11.529"
        stroke="#666666"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const ShareIcon = ({ color = '#000000' }) => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M7.93122 22H7.911C7.78213 21.9957 7.65919 21.9442 7.56504 21.855C7.47088 21.7659 7.41191 21.6452 7.39908 21.5154C7.38152 21.3215 6.93507 16.679 9.75803 13.5064C11.3236 11.7462 13.5718 10.8045 16.4453 10.7022V8.53865C16.4453 8.4343 16.4752 8.33218 16.5315 8.24472C16.5878 8.15727 16.6679 8.08823 16.7622 8.04602C16.8565 8.00381 16.9609 7.99024 17.0627 8.00696C17.1645 8.02367 17.2593 8.06996 17.3356 8.14019L23.1891 13.5247C23.2439 13.5752 23.2878 13.6367 23.3178 13.7053C23.3478 13.7739 23.3633 13.8482 23.3633 13.9232C23.3633 13.9982 23.3478 14.0724 23.3178 14.141C23.2878 14.2097 23.2439 14.2712 23.1891 14.3216L17.3356 19.7062C17.2593 19.7764 17.1645 19.8227 17.0627 19.8394C16.9609 19.8561 16.8565 19.8426 16.7622 19.8004C16.6679 19.7581 16.5878 19.6891 16.5315 19.6017C16.4752 19.5142 16.4453 19.4121 16.4453 19.3077V17.1038C14.7872 16.9816 9.28656 16.9305 8.45484 21.5579C8.43253 21.682 8.3679 21.7942 8.27221 21.875C8.17652 21.9558 8.05584 22 7.93122 22ZM17.5096 9.75609V11.2309C17.5096 11.3737 17.4535 11.5107 17.3538 11.6117C17.254 11.7126 17.1186 11.7694 16.9775 11.7694C14.1625 11.7694 11.9999 12.5959 10.5488 14.2269C9.49312 15.4883 8.81426 17.0278 8.59159 18.6654C11.239 15.3485 16.9775 16.0711 17.0477 16.0808C17.1757 16.098 17.2931 16.1618 17.3781 16.2601C17.4631 16.3585 17.5098 16.4848 17.5096 16.6155V18.0903L22.0397 13.9232L17.5096 9.75609Z"
        fill={color}
      />
    </svg>
  );
};
const EyeIcon = ({ color = '#000000' }) => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.363281"
        width="30"
        height="30"
        rx="5"
        fill={color}
      />
      <path
        d="M24.2966 15.0371C24.1549 14.8308 20.7483 10 15.3632 10C10.7424 10 6.62484 14.8031 6.45159 15.0078C6.33385 15.1473 6.33385 15.3521 6.45159 15.4923C6.62484 15.6971 10.7424 20.5002 15.3632 20.5002C19.9841 20.5002 24.1016 15.6971 24.2749 15.4923C24.3836 15.3634 24.3934 15.1766 24.2966 15.0371ZM15.3632 19.7502C11.6589 19.7502 8.13686 16.2176 7.24212 15.2501C8.13539 14.2819 11.6537 10.75 15.3632 10.75C19.6976 10.75 22.7569 14.2774 23.5039 15.2299C22.6413 16.1666 19.099 19.7502 15.3632 19.7502Z"
        fill={color}
      />
      <path
        d="M15.3633 12.251C13.7088 12.251 12.3633 13.5965 12.3633 15.251C12.3633 16.9055 13.7088 18.2511 15.3633 18.2511C17.0178 18.2511 18.3634 16.9055 18.3634 15.251C18.3634 13.5965 17.0178 12.251 15.3633 12.251ZM15.3633 17.5011C14.1228 17.5011 13.1133 16.4916 13.1133 15.2511C13.1133 14.0105 14.1228 13.001 15.3633 13.001C16.6038 13.001 17.6134 14.0105 17.6134 15.2511C17.6134 16.4916 16.6038 17.5011 15.3633 17.5011Z"
        fill={color}
      />
    </svg>
  );
};

const Todo = ({ color = '#000000' }) => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M20.4922 8.10938H18.8195C18.6018 7.49558 18.0156 7.05469 17.3281 7.05469H16.7104C16.4928 6.44082 15.9063 6 15.2188 6C14.5312 6 13.9447 6.44082 13.7271 7.05469H13.1094C12.4219 7.05469 11.8357 7.49558 11.618 8.10938H9.94531C9.07298 8.10938 8.36328 8.81907 8.36328 9.69141V22.418C8.36328 23.2903 9.07298 24 9.94531 24H20.4922C21.3645 24 22.0742 23.2903 22.0742 22.418V9.69141C22.0742 8.81907 21.3645 8.10938 20.4922 8.10938ZM12.582 8.63672C12.582 8.34594 12.8186 8.10938 13.1094 8.10938H14.1641C14.4553 8.10938 14.6914 7.87327 14.6914 7.58203C14.6914 7.29125 14.928 7.05469 15.2188 7.05469C15.5095 7.05469 15.7461 7.29125 15.7461 7.58203C15.7461 7.87327 15.9822 8.10938 16.2734 8.10938H17.3281C17.6189 8.10938 17.8555 8.34594 17.8555 8.63672V9.16406H12.582V8.63672ZM21.0195 22.418C21.0195 22.7087 20.783 22.9453 20.4922 22.9453H9.94531C9.65454 22.9453 9.41797 22.7087 9.41797 22.418V9.69141C9.41797 9.40063 9.65454 9.16406 9.94531 9.16406H11.5273V9.69141C11.5273 9.98264 11.7635 10.2188 12.0547 10.2188H18.3828C18.674 10.2188 18.9102 9.98264 18.9102 9.69141V9.16406H20.4922C20.783 9.16406 21.0195 9.40063 21.0195 9.69141V22.418Z"
        fill={color}
      />
      <path
        d="M14.5369 15.1896C14.331 14.9837 13.9971 14.9837 13.7912 15.1896L12.0547 16.9261L11.3729 16.2443C11.167 16.0383 10.8331 16.0383 10.6271 16.2443C10.4212 16.4502 10.4212 16.7841 10.6271 16.99L11.6818 18.0448C11.7848 18.1477 11.9197 18.1992 12.0547 18.1992C12.1897 18.1992 12.3246 18.1477 12.4276 18.0448L14.5369 15.9354C14.7429 15.7294 14.7429 15.3956 14.5369 15.1896Z"
        fill={color}
      />
      <path
        d="M14.5369 11.4987C14.331 11.2928 13.9971 11.2928 13.7912 11.4987L12.0547 13.2352L11.3729 12.5533C11.167 12.3474 10.8331 12.3474 10.6271 12.5533C10.4212 12.7593 10.4212 13.0932 10.6271 13.2991L11.6818 14.3538C11.7848 14.4568 11.9197 14.5083 12.0547 14.5083C12.1897 14.5083 12.3246 14.4568 12.4276 14.3538L14.5369 12.2445C14.7429 12.0385 14.7429 11.7046 14.5369 11.4987Z"
        fill={color}
      />
      <path
        d="M14.5369 18.8796C14.331 18.6736 13.9971 18.6736 13.7912 18.8796L12.0547 20.6161L11.3729 19.9343C11.167 19.7283 10.8331 19.7283 10.6271 19.9343C10.4212 20.1402 10.4212 20.4741 10.6271 20.68L11.6818 21.7347C11.7848 21.8377 11.9197 21.8892 12.0547 21.8892C12.1897 21.8892 12.3246 21.8377 12.4276 21.7347L14.5369 19.6253C14.7429 19.4194 14.7429 19.0855 14.5369 18.8796Z"
        fill={color}
      />
      <path
        d="M19.4375 12.3984H16.2734C15.9822 12.3984 15.7461 12.6345 15.7461 12.9258C15.7461 13.217 15.9822 13.4531 16.2734 13.4531H19.4375C19.7287 13.4531 19.9648 13.217 19.9648 12.9258C19.9648 12.6345 19.7287 12.3984 19.4375 12.3984Z"
        fill={color}
      />
      <path
        d="M19.4375 19.7812H16.2734C15.9822 19.7812 15.7461 20.0174 15.7461 20.3086C15.7461 20.5998 15.9822 20.8359 16.2734 20.8359H19.4375C19.7287 20.8359 19.9648 20.5998 19.9648 20.3086C19.9648 20.0174 19.7287 19.7812 19.4375 19.7812Z"
        fill={color}
      />
      <path
        d="M19.4375 16.0913H16.2734C15.9822 16.0913 15.7461 16.3274 15.7461 16.6187C15.7461 16.9099 15.9822 17.146 16.2734 17.146H19.4375C19.7287 17.146 19.9648 16.9099 19.9648 16.6187C19.9648 16.3274 19.7287 16.0913 19.4375 16.0913Z"
        fill={color}
      />
    </svg>
  );
};

const FileCopy = ({ color = '#000000' }) => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke={color}
      />
      <path
        d="M19.9234 9.73628C19.8833 9.68948 19.8343 9.65103 19.7794 9.62313C19.7244 9.59524 19.6645 9.57844 19.6031 9.5737C19.5416 9.56896 19.4798 9.57637 19.4213 9.5955C19.3627 9.61464 19.3084 9.64512 19.2616 9.68522C19.2148 9.72532 19.1764 9.77424 19.1485 9.8292C19.1206 9.88416 19.1038 9.94407 19.099 10.0055C19.0943 10.067 19.1017 10.1287 19.1209 10.1873C19.14 10.2459 19.1705 10.3002 19.2106 10.347L19.9344 11.1916C19.9783 11.2429 20.0327 11.284 20.094 11.3123C20.1553 11.3406 20.222 11.3553 20.2895 11.3555H20.2907C20.358 11.3555 20.4245 11.3411 20.4857 11.3131C20.5469 11.2851 20.6013 11.2443 20.6453 11.1934L22.3671 9.20591C22.4074 9.15934 22.4382 9.10528 22.4576 9.04683C22.477 8.98837 22.4848 8.92666 22.4804 8.86521C22.476 8.80376 22.4595 8.74379 22.4319 8.68871C22.4043 8.63363 22.3661 8.58452 22.3196 8.54419C22.273 8.50386 22.2189 8.47309 22.1605 8.45365C22.102 8.43422 22.0403 8.42648 21.9789 8.43089C21.9174 8.4353 21.8574 8.45177 21.8024 8.47936C21.7473 8.50695 21.6982 8.54512 21.6578 8.59169L20.2925 10.1673L19.9234 9.73628Z"
        fill={color}
      />
      <path
        d="M22.9016 9.92152C22.7774 9.92031 22.6577 9.96809 22.5684 10.0545C22.4792 10.1409 22.4275 10.259 22.4247 10.3832C22.4178 10.7922 22.2902 11.19 22.0579 11.5268C21.8257 11.8635 21.4991 12.1241 21.1192 12.2758C20.7393 12.4276 20.3231 12.4637 19.9227 12.3796C19.5224 12.2956 19.1558 12.0952 18.869 11.8035C18.5822 11.5118 18.388 11.1419 18.3108 10.7401C18.2335 10.3384 18.2767 9.92287 18.4348 9.54561C18.5929 9.16835 18.859 8.84622 19.1996 8.61969C19.5403 8.39315 19.9402 8.2723 20.3493 8.27231C20.4737 8.27231 20.5931 8.22287 20.6811 8.13486C20.7691 8.04686 20.8185 7.9275 20.8185 7.80305C20.8185 7.67859 20.7691 7.55924 20.6811 7.47123C20.5931 7.38323 20.4737 7.33379 20.3493 7.33379C19.7535 7.33326 19.171 7.51036 18.6764 7.84247C18.6026 7.59938 18.4527 7.38637 18.2489 7.23474C18.0451 7.0831 17.798 7.00082 17.544 7H11.2999C11.2276 7.00044 11.1564 7.01776 11.0919 7.05057C11.0839 7.05454 11.0764 7.0588 11.0686 7.06326C11.0317 7.08357 10.9976 7.10877 10.9674 7.13818L7.50076 10.6047C7.41708 10.6902 7.36961 10.8047 7.36822 10.9243L7.36328 10.9228V19.3355C7.36362 19.651 7.4891 19.9534 7.71218 20.1765C7.93525 20.3996 8.23771 20.525 8.55319 20.5254H10.2116V21.6999C10.2119 22.0153 10.3373 22.3178 10.5604 22.5409C10.7835 22.764 11.086 22.8894 11.4015 22.8898H20.3923C20.7078 22.8895 21.0103 22.764 21.2334 22.5409C21.4565 22.3179 21.582 22.0154 21.5823 21.6999V13.0927C22.1033 12.8576 22.547 12.4798 22.8622 12.003C23.1774 11.5262 23.3511 10.9698 23.3632 10.3984C23.3652 10.274 23.3177 10.1538 23.2311 10.0644C23.1445 9.975 23.026 9.9236 22.9016 9.92152ZM10.8306 8.60199V10.2227C10.8305 10.2875 10.8047 10.3497 10.7589 10.3955C10.713 10.4414 10.6509 10.4672 10.586 10.4673H8.96538L10.8306 8.60199ZM10.3491 12.969C10.3048 13.0139 10.2701 13.0674 10.2472 13.1261C10.2242 13.1848 10.2134 13.2476 10.2154 13.3106L10.2116 13.3088V19.5869H8.55319C8.48655 19.5867 8.42267 19.5602 8.37555 19.5131C8.32842 19.466 8.3019 19.4021 8.3018 19.3355V11.4057H10.586C10.8997 11.4053 11.2004 11.2805 11.4222 11.0587C11.644 10.8369 11.7688 10.5362 11.7691 10.2226V7.93852H17.544C17.6106 7.93862 17.6745 7.96514 17.7216 8.01226C17.7688 8.05939 17.7953 8.12327 17.7954 8.18991V8.75422C17.6753 8.9459 17.5772 9.15056 17.5031 9.36428H14.1451L14.1459 9.369C14.0228 9.36783 13.9041 9.41558 13.8161 9.50176L10.3491 12.969ZM13.6786 10.9665V12.5872C13.6785 12.6519 13.6527 12.714 13.607 12.7598C13.5612 12.8056 13.4991 12.8314 13.4343 12.8315H11.8137L13.6786 10.9665ZM20.6438 21.6999C20.6437 21.7665 20.6172 21.8304 20.57 21.8775C20.5229 21.9246 20.459 21.9511 20.3924 21.9512H11.4015C11.3348 21.9511 11.271 21.9246 11.2238 21.8775C11.1767 21.8304 11.1502 21.7665 11.1501 21.6999V13.7699H13.4343C13.7479 13.7695 14.0486 13.6448 14.2704 13.4231C14.4921 13.2013 14.6168 12.9006 14.6172 12.587V10.3028H17.3371C17.3368 10.3181 17.3348 10.3328 17.3348 10.3481C17.3357 11.1473 17.6536 11.9134 18.2187 12.4785C18.7838 13.0436 19.5499 13.3615 20.3491 13.3624C20.4485 13.3624 20.5467 13.3571 20.6437 13.3475L20.6438 21.6999Z"
        fill={color}
      />
      <path
        d="M18.8971 14.6562H12.7739C12.6495 14.6563 12.5301 14.7057 12.4421 14.7937C12.3541 14.8817 12.3047 15.0011 12.3047 15.1255C12.3047 15.25 12.3541 15.3693 12.4421 15.4573C12.5301 15.5453 12.6495 15.5948 12.7739 15.5948H18.8971C19.0215 15.5948 19.1409 15.5453 19.2289 15.4573C19.3169 15.3693 19.3663 15.25 19.3663 15.1255C19.3663 15.0011 19.3169 14.8817 19.2289 14.7937C19.1409 14.7057 19.0215 14.6562 18.8971 14.6562Z"
        fill={color}
      />
      <path
        d="M16.9041 16.3159H12.7739C12.6495 16.3159 12.5301 16.3654 12.4421 16.4534C12.3541 16.5414 12.3047 16.6607 12.3047 16.7852C12.3047 16.9096 12.3541 17.029 12.4421 17.117C12.5301 17.205 12.6495 17.2544 12.7739 17.2544H16.9041C17.0285 17.2544 17.1479 17.205 17.2359 17.117C17.3239 17.029 17.3733 16.9096 17.3733 16.7852C17.3733 16.6607 17.3239 16.5414 17.2359 16.4534C17.1479 16.3654 17.0285 16.3159 16.9041 16.3159Z"
        fill={color}
      />
      <path
        d="M16.9028 19.4595H15.8475C15.7614 19.4593 15.6788 19.4251 15.6178 19.3642C15.5569 19.3032 15.5227 19.2206 15.5225 19.1345V19.0648C15.5225 18.9328 15.4866 18.8032 15.4187 18.6901C15.3507 18.5769 15.2532 18.4843 15.1367 18.4223C15.0202 18.3602 14.889 18.3311 14.7571 18.3379C14.6253 18.3447 14.4978 18.3872 14.3883 18.4609L12.7856 19.5393C12.6823 19.6088 12.6108 19.7164 12.5869 19.8386C12.563 19.9607 12.5885 20.0874 12.658 20.1906C12.7274 20.2939 12.8351 20.3654 12.9572 20.3893C13.0793 20.4132 13.206 20.3877 13.3093 20.3182L14.6205 19.4362C14.6883 19.7105 14.846 19.9542 15.0684 20.1285C15.2908 20.3028 15.5651 20.3977 15.8476 20.3981H16.9029C17.0274 20.3981 17.1467 20.3486 17.2347 20.2606C17.3227 20.1726 17.3722 20.0533 17.3722 19.9288C17.3722 19.8044 17.3227 19.685 17.2347 19.597C17.1467 19.509 17.0274 19.4595 16.9029 19.4595L16.9028 19.4595Z"
        fill={color}
      />
      <path
        d="M18.8957 19.4585H18.3521C18.2276 19.4585 18.1083 19.5079 18.0203 19.5959C17.9323 19.6839 17.8828 19.8033 17.8828 19.9278C17.8828 20.0522 17.9323 20.1716 18.0203 20.2596C18.1083 20.3476 18.2276 20.397 18.3521 20.397H18.8957C19.0201 20.397 19.1395 20.3476 19.2275 20.2596C19.3155 20.1716 19.3649 20.0522 19.3649 19.9278C19.3649 19.8033 19.3155 19.6839 19.2275 19.5959C19.1395 19.5079 19.0201 19.4585 18.8957 19.4585Z"
        fill={color}
      />
    </svg>
  );
};

const File = ({ color = '#000000' }) => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M21.5633 11.622C21.5673 11.3595 21.5195 11.0989 21.4228 10.8549C21.326 10.6109 21.1821 10.3884 20.9993 10.2L17.4893 6.6C17.3007 6.40988 17.0764 6.25898 16.8293 6.156C16.5821 6.05302 16.317 6 16.0493 6H10.3733C9.8402 6 9.32894 6.21177 8.952 6.58872C8.57505 6.96566 8.36328 7.47691 8.36328 8.01V21.99C8.36328 22.5231 8.57505 23.0343 8.952 23.4113C9.32894 23.7882 9.8402 24 10.3733 24H19.5533C19.8172 24 20.0786 23.948 20.3225 23.847C20.5663 23.746 20.7879 23.5979 20.9746 23.4113C21.1612 23.2246 21.3093 23.0031 21.4103 22.7592C21.5113 22.5153 21.5633 22.254 21.5633 21.99V11.622ZM19.5593 10.47H17.7053C17.6435 10.4752 17.5813 10.4678 17.5225 10.4482C17.4637 10.4286 17.4095 10.3972 17.3633 10.356C17.2789 10.2717 17.2314 10.1573 17.2313 10.038V8.082L19.5593 10.47ZM19.5593 22.8H10.3733C10.2667 22.8008 10.161 22.7804 10.0624 22.74C9.96373 22.6995 9.87412 22.6399 9.79874 22.5645C9.72337 22.4892 9.66374 22.3996 9.62331 22.3009C9.58289 22.2023 9.56248 22.0966 9.56328 21.99V8.01C9.56248 7.90341 9.58289 7.79772 9.62331 7.69908C9.66374 7.60045 9.72337 7.51084 9.79874 7.43546C9.87412 7.36009 9.96373 7.30045 10.0624 7.26003C10.161 7.21961 10.2667 7.1992 10.3733 7.2H16.0433V10.038C16.0433 10.2552 16.0862 10.4702 16.1695 10.6708C16.2527 10.8714 16.3748 11.0536 16.5287 11.2069C16.6825 11.3601 16.8651 11.4816 17.066 11.5641C17.2669 11.6467 17.4821 11.6888 17.6993 11.688L20.3633 11.658V21.99C20.3641 22.0966 20.3437 22.2023 20.3032 22.3009C20.2628 22.3996 20.2032 22.4892 20.1278 22.5645C20.0524 22.6399 19.9628 22.6995 19.8642 22.74C19.7656 22.7804 19.6599 22.8008 19.5533 22.8H19.5593Z"
        fill={color}
      />
      <path
        d="M17.3648 13.3438H12.5648C12.4057 13.3438 12.2531 13.407 12.1406 13.5195C12.0281 13.632 11.9648 13.7846 11.9648 13.9437C11.9648 14.1029 12.0281 14.2555 12.1406 14.368C12.2531 14.4805 12.4057 14.5437 12.5648 14.5437H17.3648C17.524 14.5437 17.6766 14.4805 17.7891 14.368C17.9016 14.2555 17.9648 14.1029 17.9648 13.9437C17.9648 13.7846 17.9016 13.632 17.7891 13.5195C17.6766 13.407 17.524 13.3438 17.3648 13.3438Z"
        fill={color}
      />
      <path
        d="M17.3648 17.2617H12.5648C12.4057 17.2617 12.2531 17.3249 12.1406 17.4375C12.0281 17.55 11.9648 17.7026 11.9648 17.8617C11.9648 18.0208 12.0281 18.1735 12.1406 18.286C12.2531 18.3985 12.4057 18.4617 12.5648 18.4617H17.3648C17.524 18.4617 17.6766 18.3985 17.7891 18.286C17.9016 18.1735 17.9648 18.0208 17.9648 17.8617C17.9648 17.7026 17.9016 17.55 17.7891 17.4375C17.6766 17.3249 17.524 17.2617 17.3648 17.2617Z"
        fill={color}
      />
    </svg>
  );
};

const Downloaded = ({ color = '#000000' }) => {
  return (
    <svg
      width="41"
      height="40"
      viewBox="0 0 31 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.1"
        x="0.863281"
        y="0.5"
        width="29"
        height="29"
        rx="4.5"
        stroke="#112347"
      />
      <path
        d="M17.0678 13.8406C16.9172 13.6899 16.6722 13.6899 16.5215 13.8406L15.636 14.7261V6.38636C15.636 6.1731 15.4629 6 15.2496 6C15.0364 6 14.8633 6.1731 14.8633 6.38636V15.6588C14.8633 15.8149 14.9576 15.9563 15.102 16.0158C15.15 16.0359 15.2002 16.0451 15.2496 16.0451C15.3501 16.0451 15.449 16.0057 15.5224 15.9323L17.0678 14.3869C17.2185 14.2363 17.2185 13.9913 17.0678 13.8406Z"
        fill={color}
      />
      <path
        d="M15.5211 15.386L13.9757 13.8405C13.825 13.6899 13.5801 13.6899 13.4294 13.8405C13.2787 13.9912 13.2787 14.2362 13.4294 14.3869L14.9748 15.9323C15.0506 16.0072 15.1494 16.0451 15.2484 16.0451C15.3473 16.0451 15.4462 16.0072 15.5211 15.9323C15.6718 15.7816 15.6718 15.5366 15.5211 15.386Z"
        fill={color}
      />
      <path
        d="M23.6811 14.4742L20.8955 10.2954C20.3925 9.54129 19.551 9.09082 18.6454 9.09082H16.7948C16.5815 9.09082 16.4084 9.26392 16.4084 9.47718C16.4084 9.69045 16.5815 9.86355 16.7948 9.86355H18.6454C19.2921 9.86355 19.8933 10.185 20.2526 10.7236L23.0382 14.9023C23.2507 15.2207 23.3627 15.5916 23.3627 15.9741V21.0677C23.3627 21.7067 22.8427 22.2268 22.2037 22.2268H8.29502C7.65599 22.2268 7.13597 21.7067 7.13597 21.0677V16.0312C7.13597 15.6178 7.26502 15.223 7.52078 14.8729L10.0197 11.0805C10.522 10.3179 11.3665 9.86351 12.2783 9.86351H13.7039C13.9172 9.86351 14.0903 9.69041 14.0903 9.47715C14.0903 9.26388 13.9172 9.09082 13.704 9.09082H12.2783C11.1054 9.09082 10.0197 9.67574 9.3745 10.6555L6.88641 14.4325C6.54409 14.9 6.36328 15.4525 6.36328 16.0312V21.0677C6.36328 22.1325 7.23025 22.9994 8.29502 22.9994H22.2037C23.2684 22.9994 24.1354 22.1325 24.1354 21.0677V15.974C24.1354 15.4386 23.9786 14.9201 23.6811 14.4742Z"
        fill={color}
      />
      <path
        d="M23.3631 15.2725H21.4314C20.3666 15.2725 19.4996 16.1394 19.4996 17.2042C19.4996 17.8432 18.9796 18.3633 18.3406 18.3633H12.1589C11.5199 18.3633 10.9999 17.8432 10.9999 17.2042C10.9999 16.1394 10.1329 15.2725 9.06814 15.2725H7.13636C6.9231 15.2725 6.75 15.4456 6.75 15.6588C6.75 15.8721 6.9231 16.0452 7.13636 16.0452H9.0681C9.70714 16.0452 10.2272 16.5652 10.2272 17.2042C10.2272 18.269 11.0941 19.1359 12.1589 19.1359H18.3405C19.4053 19.1359 20.2723 18.269 20.2723 17.2042C20.2723 16.5652 20.7923 16.0452 21.4314 16.0452H23.3631C23.5764 16.0452 23.7495 15.8721 23.7495 15.6588C23.7495 15.4455 23.5764 15.2725 23.3631 15.2725Z"
        fill={color}
      />
    </svg>
  );
};

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress
        variant="determinate"
        value={props.rating * 10}
        sx={{ color: '#10D35E' }}
        thickness={5}
        size={40}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="caption"
          component="div"
          sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
        >
          {props.rating == null ? 0 : props.rating}
        </Typography>
      </Box>
    </Box>
  );
}
const GreyPaper = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#C4C4C4"
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
      />
    </svg>
  );
};
const ColorPaper = () => {
  return (
    <svg
      width="29"
      height="29"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.2424 3.15798C17.193 3.14914 17.142 3.14453 17.09 3.14453C17.038 3.14453 16.9871 3.14914 16.9376 3.15798H9.75493C6.89987 3.15798 4.49316 5.47416 4.49316 8.29922V20.5962C4.49316 23.5813 6.79415 25.9463 9.75493 25.9463H18.9251C21.7412 25.9463 24.0664 23.4648 24.0664 20.5962V10.075C24.0664 9.85271 23.9804 9.63908 23.8265 9.47876L18.0126 3.42268C17.8503 3.25357 17.626 3.15798 17.3916 3.15798H17.2424ZM16.2291 4.87884L9.75482 4.87976C7.83622 4.87976 6.21484 6.44015 6.21484 8.29922V20.5962C6.21484 22.6408 7.7557 24.2246 9.75482 24.2246H18.925C20.7642 24.2246 22.3445 22.538 22.3445 20.5962L22.3437 11.1601L21.3389 11.1635C20.9559 11.1631 20.5203 11.1622 20.0359 11.1611C18.0047 11.1569 16.3471 9.56481 16.2352 7.56077L16.2291 7.34453V4.87884ZM21.4015 9.43918L20.0397 9.43937C18.8855 9.43693 17.9509 8.4998 17.9509 7.34453V5.84489L21.4015 9.43918ZM16.872 17.8458C17.3475 17.8458 17.7329 18.2312 17.7329 18.7067C17.7329 19.1425 17.409 19.5027 16.9888 19.5597L16.872 19.5676H10.6771C10.2016 19.5676 9.81617 19.1821 9.81617 18.7067C9.81617 18.2709 10.14 17.9107 10.5602 17.8537L10.6771 17.8458H16.872ZM15.3896 13.0223C15.3896 12.5468 15.0041 12.1614 14.5287 12.1614H10.6765L10.5596 12.1692C10.1394 12.2262 9.81557 12.5864 9.81557 13.0223C9.81557 13.4977 10.201 13.8832 10.6765 13.8832H14.5287L14.6455 13.8753C15.0657 13.8183 15.3896 13.4581 15.3896 13.0223Z"
        fill="#6C2AD2"
      />
    </svg>
  );
};
const UserNameUpArrow = () => {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.49442 4.95907C9.33615 5.11699 9.08847 5.13135 8.91395 5.00214L8.86394 4.95907L5.29167 1.39474L1.71939 4.95907C1.56112 5.11699 1.31344 5.13135 1.13891 5.00214L1.08891 4.95907C0.930635 4.80116 0.916247 4.55405 1.04574 4.37991L1.08891 4.33002L4.97643 0.45131C5.1347 0.293394 5.38238 0.279038 5.5569 0.408242L5.60691 0.45131L9.49442 4.33002C9.66853 4.50373 9.66853 4.78537 9.49442 4.95907Z"
        fill="black"
      />
    </svg>
  );
};
const TrophyIcon = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5842 12.9359C13.9042 11.9239 15.8402 10.4279 15.8402 4.8399V4.3999H6.16016V4.8399C6.16016 10.4279 8.14016 11.9239 9.41616 12.9359C10.1642 13.5079 10.5602 13.8159 10.5602 14.5199V15.8399C9.85616 15.9279 9.15216 16.1919 8.88816 16.7199H7.92016C7.43616 16.7199 7.04016 17.1159 7.04016 17.5999H14.9602C14.9602 17.1159 14.5642 16.7199 14.0802 16.7199H13.1122C12.8482 16.1919 12.1882 15.9279 11.4402 15.8399V14.5199C11.4402 13.8159 11.7922 13.5079 12.5842 12.9359ZM11.0002 13.1559C10.7362 12.8039 10.3402 12.4959 9.98816 12.2319C8.80016 11.3079 7.17216 10.0759 7.08416 5.2799H15.0042C14.9162 10.0319 13.2882 11.3079 12.1002 12.2319C11.6602 12.5399 11.2642 12.8039 11.0002 13.1559Z"
        fill="#2F3F5E"
      />
      <path
        d="M8.27153 11.8798C8.22753 11.8798 3.51953 10.8678 3.51953 5.71979V5.27979H6.59953V6.15979H4.39953C4.66353 10.2078 8.40353 10.9998 8.44753 10.9998L8.27153 11.8798Z"
        fill="#2F3F5E"
      />
      <path
        d="M13.7268 11.8798L13.5508 10.9998C13.7268 10.9558 17.3348 10.1638 17.5988 6.15979H15.3988V5.27979H18.4788V5.71979C18.4788 10.8678 13.7708 11.8798 13.7268 11.8798Z"
        fill="#2F3F5E"
      />
    </svg>
  );
};

const ExpIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.7626 6.80661C14.7626 9.18634 12.8546 11.0945 10.4732 11.0945C8.0926 11.0945 6.18374 9.18634 6.18374 6.80661C6.18374 4.42688 8.0926 2.51953 10.4732 2.51953C12.8546 2.51953 14.7626 4.42688 14.7626 6.80661ZM10.4732 18.7245C6.95865 18.7245 3.99121 18.1533 3.99121 15.9494C3.99121 13.7447 6.97729 13.1937 10.4732 13.1937C13.9886 13.1937 16.9552 13.7649 16.9552 15.9689C16.9552 18.1736 13.9691 18.7245 10.4732 18.7245Z"
        fill="#F74646"
      />
    </svg>
  );
};

const TableAccordion = ({
  setBuyerRegisterChecked,
  vendorside,
  BlueTick,
  Monetize,
  vendorstatustable,
  forwardtootherbuyerstatus,
  handleClickBuyer,
  buyerId,
  userType,
  collectId,
  setShowBackDrop,
  setBuyerId,
  setPosition,
  setArrayCollection,
  BuyerDropdown,
  setBuyerDropdown,
  tableData,
  currentItems,
  finalCon,
  selectedBuyers,
  isSelected,
  selectedrowbuyeridfilter,
  directcomm,
  userType1,
  setOfferUniqueId,
  openBox,
  setOpenPublishWinnerBox,
  setOpenBox,
  buyerRegisterCheckBox,
  setSelectedrowbuyerid,
  selectedrowbuyerid,
  setbuyerOfferPrice,
  forwardtobuyer,
  propertyDetails,
  offerUniqueId,
  onShowChat,
  setOpenFeedback,
  buyerRegisterCheckBoxArr,
  forwardBuyersOfferToOtherBuyers,
  setTableChecked,
  tableChecked,
  setForwardtobuyer,
  updatefunc,
  getListInfo,
  address,
  buyerRegisterChecked,
  handleClick,
  setSelectedrowbuyername,
  selectedrowbuyername,
  buyerOfferPrice,
  userTypeValue,
  reqDepositOpen,
  propertyId,
  setItemObj,
  setVendorAction,
  setReqDepositOpen,
  buyeroffer,
  StageTwo,
  setManageofferrow,
  setManageOffer,
  idBuyer,
  buyerReadiness,
  idExp,
  buyerExp,
  idProperty,
  buyerProfile,
  propertyProgress,
  offerHistory,
  setOfferHistory,
  showBackdrop,
  selectCheckBox,
  setSelectedCheckboxes,
  vendorDatas,
  manageOffer,
  openhistorydialog,
  manageofferrow,
  setIsSwalOpen,
  setisVendorHistoryId,
  setOpenhistorydialog,
  isVendorHistoryId,
  manageOfferClickClose,
  profileData,
  setBuyerRegisterCheckBox,
  setPaymentStatus,
  setBuyerRegisterCheckBoxArr,
  setVendorGeneratePdf,
  userDetail,
}) => {
  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 16,
    position: 'relative',
    [`&.${linearProgressClasses.colorPrimary}`]: {
      background: '#FFFFFF',
      border: '0.81px solid',
      borderRadius: 2.42,
      borderColor: '#6C2AD2',
    },
    [`& .${linearProgressClasses.bar}`]: {
      background:
        'linear-gradient(140.46deg, #6C2AD2 -27.13%, #77CFFE 121.57%)',
      borderRadius: 2.42,
      transition: 'none',
    },
  }));
  const TextOverlay = styled(Typography)(({ theme, leftPosition }) => ({
    position: 'absolute',
    top: '50%',
    left: `${leftPosition}%`,
    transform: 'translate(-50%, -50%)',
    zIndex: 1,
    fontSize: '10px',
    fontFamily: 'Poppins',
    color: '#FFFFFF',
    fontWeight: '400px',
    alignItems: 'center',
  }));

  function LinearProgressBarWithPercentage(props) {
    const rediness = props.rediness || 0;
    return (
      <div style={{ position: 'relative', cursor: 'pointer' }}>
        <BorderLinearProgress variant="determinate" value={props.value} />
        <TextOverlay
          sx={{ color: 'white', textShadow: '-1px 1px 0px black' }}
          variant="body2"
          color="textSecondary"
          leftPosition={'50%'}
        >
          {`${Math.round(props.value)}%`}
        </TextOverlay>
      </div>
    );
  }

  const [expandedPanel, setExpandedPanel] = useState(null);
  const [expandAcc, setExpandAcc] = useState(false);
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));

  const CircularProgressWithProfile = (props) => {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={30}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={30}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props?.profileImage == '' || props?.profileImage == null ? (
              <Avatar
                style={{
                  width: '25px',
                  height: '25px',
                  fontFamily: 'poppins',
                  fontSize: matchessm ? '14px' : '20px',
                  backgroundColor: '#666666',
                }}
              >
                {props.name}
              </Avatar>
            ) : (
              <Avatar
                alt="Profile Image"
                src={props?.profileImage}
                style={{
                  width: '25px',
                  height: '25px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  };
  const CircularProgressWithProfileVendor = (props) => {
    return (
      <Box sx={{ position: 'relative', display: 'inline-flex' }}>
        <CircularProgress
          variant="determinate"
          value={100}
          sx={{ color: '#C4C4C461' }}
          thickness={5}
          size={30}
        />
        <CircularProgress
          variant="determinate"
          value={props.value}
          sx={{ color: '#10D35E', position: 'absolute' }}
          thickness={5}
          size={30}
        />
        <Box
          sx={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            position: 'absolute',
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: '#000000', ...poppins500, fontSize: '14px' }}
          >
            {props?.profileImage == '' || props?.profileImage == null ? (
              <Avatar
                style={{
                  width: '25px',
                  height: '25px',
                  fontFamily: 'poppins',
                  fontSize: matchessm ? '14px' : '20px',
                  backgroundColor: '#666666',
                }}
              >
                {props.name}
              </Avatar>
            ) : (
              <Avatar
                alt="Profile Image"
                src={props?.profileImage}
                style={{
                  width: '25px',
                  height: '25px',
                }}
              />
            )}
          </Typography>
        </Box>
      </Box>
    );
  };
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpandedPanel(isExpanded ? panel : null);
  };
  return (
    <Stack direction={'column'}>
      <Stack direction={'row'}>
        <Typography
          sx={{
            ...poppins400,
            fontSize: '10px',
            width: '70%',
            paddingLeft: '20px',
            color: '#666666',
          }}
        >
          Name
        </Typography>
        <Typography
          sx={{
            ...poppins400,
            fontSize: '10px',
            width: '15%',
            color: '#666666',
          }}
        >
          Status
        </Typography>
        <Typography
          sx={{
            ...poppins400,
            fontSize: '10px',
            width: '15%',
            color: '#666666',
          }}
        >
          Action
        </Typography>
      </Stack>
      {tableData && Array.isArray(currentItems) && currentItems?.length > 0 ? (
        currentItems?.map((row, index) => {
          const buyerId = row?.buyerDetails?.user?.userId;
          const getUserName = (userId) => {
            const user = row?.buyerDetails?.user;
            return user?.userName || 'Unknown';
          };
          const getUserSurName = (userId) => {
            const user = row?.buyerDetails?.user;
            return user?.userSurName || 'Unknown';
          };
          const propertyOfferBuyerId =
            row?.buyerOfferDetails?.offerUniqueId || buyerId;
          const offerStatusVendor = row?.buyerOfferDetails?.offerStatusVendor;
          const offerStatus = row?.buyerOfferDetails?.offerStatus;
          const isCardSelected = selectedBuyers.includes(buyerId);
          const userType = row?.buyerDetails?.userCategory[0]?.userType;
          const userCategory = row?.buyerDetails?.userCategory;
          const isItemSelected = isSelected(row.name);
          const labelId = `enhanced-table-checkbox-${index}`;
          if (row?.buyerOfferDetails) {
            if (
              row?.buyerOfferDetails?.contractSignStatus == 'Action Required'
            ) {
              finalCon = false;
            } else if (
              row?.buyerOfferDetails?.contractSignStatus == 'E-sign Requested'
            ) {
              finalCon = false;
            }
          } else {
            finalCon = true;
          }

          if (buyerId !== selectedrowbuyeridfilter) {
            return (
              <>
                <Accordion
                  key={index}
                  expanded={expandAcc ? expandedPanel === index : false}
                  onChange={handleAccordionChange(index)}
                  sx={{
                    boxShadow: 'none',
                    border: 'none',
                    margin: '0px',
                    padding: '0px',
                    '&:before': { display: 'none' },
                    '& .Mui-expanded': {
                      marginTop: '0px',
                      height: '78px',
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{
                      '& .MuiAccordionSummary-expandIconWrapper': {
                        display: 'none',
                      },

                      '& .MuiAccordionSummary-root': {
                        margin: '0px',
                        paddingLeft: '0px !important',
                      },
                      paddingRight: '0px',
                      borderBottom: '1px solid #F0F0F0',
                    }}
                  >
                    <Grid
                      container
                      sx={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                        marginTop: '3px',
                        padding: '0px !important',
                      }}
                    >
                      <Grid
                        item
                        m={0}
                        p={0}
                        sx={{
                          width: '70%',
                          padding: '0px !important',
                        }}
                      >
                        <Typography
                          sx={{ ...imageCont, padding: '0px', margin: '0px' }}
                        >
                          {!vendorstatustable &&
                            !vendorside &&
                            !forwardtootherbuyerstatus && (
                              <Typography
                                style={{ padding: '20px 5px 20px 10px' }}
                              >
                                <input
                                  type="checkbox"
                                  color="primary"
                                  checked={
                                    (showBackdrop && isCardSelected) ||
                                    buyerRegisterCheckBox.includes(
                                      row?.buyerDetails?.user?.userId
                                    )
                                  }
                                  onClick={(event) => {
                                    event.stopPropagation();
                                    selectCheckBox(
                                      row?.buyerDetails?.user?.userId,
                                      'updateId'
                                    );
                                    setSelectedCheckboxes((prev) =>
                                      prev.includes(
                                        row?.buyerDetails?.user?.userId
                                      )
                                        ? prev.filter(
                                            (id) =>
                                              id !==
                                              row?.buyerDetails?.user?.userId
                                          )
                                        : [
                                            ...prev,
                                            row?.buyerDetails?.user?.userId,
                                          ]
                                    );
                                  }}
                                  inputProps={{
                                    'aria-labelledby': labelId,
                                  }}
                                />
                              </Typography>
                            )}
                          {!vendorside && (
                            <Typography
                              sx={{
                                ...displayFlex,
                                justifyContent: 'flex-start',
                                position: 'relative',
                                alignItems: 'center',
                                marginRight: '10px',
                                width: '30px',
                                height: '30px',
                              }}
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                            >
                              <CircularProgressWithProfile
                                value={row?.buyerDetails?.profileActivity}
                                profileImage={
                                  row?.buyerDetails?.user?.userProfile
                                }
                                name={
                                  row?.buyerDetails?.user?.userName
                                    .charAt(0)
                                    ?.toUpperCase() +
                                  row?.buyerDetails?.user?.userSurName
                                    .charAt(0)
                                    ?.toUpperCase()
                                }
                              />
                            </Typography>
                          )}
                          {vendorside && (
                            <Typography
                              sx={displayFlex}
                              style={{
                                justifyContent: 'center',
                                position: 'relative',
                                alignItems: 'center',
                                marginRight: '10px',
                              }}
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                            >
                              <CircularProgressWithProfileVendor
                                value={row?.buyerDetails?.profileActivity}
                                profileImage={
                                  row?.buyerDetails?.user?.userProfile
                                }
                                name={
                                  row?.buyerDetails?.user?.userName
                                    .charAt(0)
                                    ?.toUpperCase() +
                                  row?.buyerDetails?.user?.userSurName
                                    .charAt(0)
                                    ?.toUpperCase()
                                }
                              />
                            </Typography>
                          )}
                          {vendorstatustable && !vendorside && (
                            <Typography
                              sx={(displayFlex, { cursor: 'pointer' })}
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                            >
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  wordWrap: 'break-word',
                                  overflowWrap: 'break-word',
                                  whiteSpace: 'normal',
                                }}
                              >
                                {row?.buyerDetails?.user?.userName}
                              </Typography>
                            </Typography>
                          )}
                          {!vendorstatustable && vendorside && (
                            <Typography
                              sx={(displayFlex, { cursor: 'pointer' })}
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                            >
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  whiteSpace: 'nowrap',
                                }}
                              >
                                <span
                                  style={{
                                    textTransform: 'capitalize',
                                    wordWrap: 'break-word',
                                    overflowWrap: 'break-word',
                                    whiteSpace: 'normal',
                                  }}
                                >
                                  {row?.buyerDetails?.user?.userName}
                                </span>
                                &nbsp;
                                {row?.buyerDetails?.user?.userSurName
                                  ?.charAt(0)
                                  .toUpperCase()}
                              </Typography>
                            </Typography>
                          )}
                          {forwardtootherbuyerstatus && (
                            <Typography
                              sx={(displayFlex, { cursor: 'pointer' })}
                              onClick={(event) => {
                                event.stopPropagation();
                              }}
                            >
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '12px',
                                  cursor: 'pointer',
                                  whiteSpace: 'nowrap',
                                  wordWrap: 'break-word',
                                  overflowWrap: 'break-word',
                                }}
                              >
                                {`${row?.buyerDetails?.user?.userName} ${row?.buyerDetails?.user?.userSurName}`}
                              </Typography>
                            </Typography>
                          )}
                          {!vendorstatustable &&
                            !vendorside &&
                            !forwardtootherbuyerstatus && (
                              <Typography
                                sx={
                                  (displayFlex,
                                  { cursor: 'pointer', position: 'relative' })
                                }
                                onClick={(event) => {
                                  event.stopPropagation();
                                  handleClickBuyer(buyerId, userType, row);
                                }}
                              >
                                <Typography
                                  sx={{
                                    ...poppins400,
                                    fontSize: '12px',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                    color: '#112347',
                                    wordWrap: 'break-word',
                                    overflowWrap: 'break-word',
                                  }}
                                  onClick={(event) => {
                                    handleClickBuyer(buyerId, userType, row);
                                    setShowBackDrop(false);
                                    collectId(
                                      tableData,
                                      buyerId,
                                      setBuyerId,
                                      setPosition,
                                      setArrayCollection
                                    );
                                  }}
                                >
                                  {`${row?.buyerDetails?.user?.userName} ${row?.buyerDetails?.user?.userSurName}`}
                                </Typography>
                              </Typography>
                            )}
                          {!vendorside && (
                            <Typography
                              sx={{
                                ...imageCont,
                                padding: '0px',
                                margin: '0px',
                              }}
                            >
                              <Box
                                sx={{
                                  display: 'flex',
                                  justifyContent: 'center',
                                  alignItems: 'center',
                                }}
                              >
                                {/* IconButton should NOT be affected by stopPropagation */}
                                {BuyerDropdown !== index ? (
                                  <IconButton
                                    onClick={() => {
                                      setExpandAcc(true);
                                      setBuyerDropdown(index); // Toggle dropdown state
                                    }}
                                  >
                                    <UserNameDownArrow />
                                  </IconButton>
                                ) : (
                                  <IconButton
                                    onClick={() => {
                                      setExpandAcc(false);
                                      setBuyerDropdown(null);
                                    }}
                                  >
                                    <UserNameUpArrow />
                                  </IconButton>
                                )}
                              </Box>
                            </Typography>
                          )}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        sx={{
                          width: '15%',
                          cursor: 'pointer',
                          padding: '0px !important',
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                          }}
                        >
                          <Typography textAlign={'left'} padding={'0px'}>
                            {row?.buyerDetails?.is66Signed == 0 ? (
                              <GreyPaper />
                            ) : (
                              <ColorPaper />
                            )}
                          </Typography>
                          <Typography
                            textAlign={'left'}
                            style={{
                              fontFamily: 'Poppins',
                              fontSize: '9.69px',
                              fontWeight: '400px',
                              paddingLeft: '5px',
                              color:
                                row?.buyerDetails?.is66Signed === 0
                                  ? '#707b91'
                                  : '#6C2AD2',
                            }}
                          >
                            {'s66W'}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid
                        item
                        sx={{
                          width: '15%',
                          padding: '0px !important',
                          justifyContent: 'flex-start',
                          alignItems: 'right',
                        }}
                        onClick={(event) => event.stopPropagation()}
                      >
                        {!buyeroffer && !StageTwo && (
                          <Stack direction={'row'} spacing={vendorside ? 3 : 1}>
                            {!vendorside && (
                              <SelectMenu
                                setBuyerRegisterChecked={
                                  setBuyerRegisterChecked
                                }
                                index={index}
                                buyerRegisterCheckBoxArr={
                                  buyerRegisterCheckBoxArr
                                }
                                buyerRegisterCheckBox={buyerRegisterCheckBox}
                                buyerId={buyerId}
                                onShowChat={onShowChat}
                                setOpenBox={setOpenBox}
                                openBox={openBox}
                                setOfferUniqueId={setOfferUniqueId}
                                offerUniqueId={offerUniqueId}
                                row={row}
                                tableData={propertyDetails}
                                forwardtobuyer={forwardtobuyer}
                                setbuyerOfferPrice={setbuyerOfferPrice}
                                selectedrowbuyerid={selectedrowbuyerid}
                                setSelectedrowbuyerid={setSelectedrowbuyerid}
                                setOpenPublishWinnerBox={
                                  setOpenPublishWinnerBox
                                }
                                setTableChecked={setTableChecked}
                                tableChecked={tableChecked}
                                setForwardtobuyer={setForwardtobuyer}
                                updatefunc={updatefunc}
                                getListInfo={getListInfo}
                                address={address}
                                buyerRegisterChecked={buyerRegisterChecked}
                                handleClick={handleClick}
                                setShowBackDrop={setShowBackDrop}
                                isCardSelected={isCardSelected}
                                setSelectedrowbuyername={
                                  setSelectedrowbuyername
                                }
                                selectedrowbuyername={selectedrowbuyername}
                                buyerOfferPrice={buyerOfferPrice}
                                setOfferHistory={setOfferHistory}
                                offerHistory={offerHistory}
                                userTypeValue={userTypeValue}
                                reqDepositOpen={reqDepositOpen}
                                setReqDepositOpen={setReqDepositOpen}
                                campaignId={
                                  propertyDetails?.PropertyDetails?.campaignId
                                }
                                profileData={propertyDetails}
                                selectedCheckboxes={buyerRegisterCheckBox}
                                setSelectedCheckboxes={setSelectedCheckboxes}
                                setBuyerRegisterCheckBoxArr={
                                  setBuyerRegisterCheckBoxArr
                                }
                                setBuyerRegisterCheckBox={
                                  setBuyerRegisterCheckBox
                                }
                                latestcounterOfferPrice={
                                  propertyDetails?.latestcounterOfferPrice
                                }
                                mobileView={true}
                                propertyDetails={propertyDetails}
                                setPaymentStatus={setPaymentStatus}
                                mobileTableData={tableData} //Nominate winner error in mobile view
                              />
                            )}

                            {vendorside && (
                              <VendorSelectMenu
                                row={row}
                                setVendorAction={setVendorAction}
                                setItemObj={setItemObj}
                                acceptLog={
                                  propertyDetails?.PropertyDetails
                                    ?.isAcceptedLog
                                }
                                propertyId={propertyId}
                                getListInfo={getListInfo}
                                buyerId={buyerId}
                                onShowChat={onShowChat}
                                forwardBuyersOfferToOtherBuyers={
                                  forwardBuyersOfferToOtherBuyers
                                }
                                tableData={propertyDetails}
                                vendorside={vendorside}
                                vendorDatas={vendorDatas}
                                setIsSwalOpen={setIsSwalOpen}
                                setVendorGeneratePdf={setVendorGeneratePdf}
                              />
                            )}
                          </Stack>
                        )}
                      </Grid>
                    </Grid>
                  </AccordionSummary>
                  <AccordionDetails
                    sx={{
                      backgroundColor: '#F8F8F8',
                      borderBottom: '1px solid black',
                      borderTop: '1px solid black',
                      padding: '5px',
                      paddingTop: '13px',
                      paddingBottom: '30px',
                    }}
                  >
                    <Card variant="outlined" sx={{ borderRadius: '8px' }}>
                      <CardContent
                        sx={{
                          display: 'flex',
                          flexDirection: 'row',
                          justifyContent: 'space-between',
                          '&:last-child': {
                            paddingBottom: '10px',
                          },
                          padding: '15px',
                        }}
                      >
                        {!buyeroffer && !vendorside && (
                          <Stack
                            direction={'column'}
                            sx={{ width: '40%' }}
                            spacing={1}
                          >
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize: '10px',
                                color: '#666666',
                              }}
                            >
                              Buyer Readiness
                            </Typography>
                            <Box sx={{}}>
                              <Stack direction={'column'} sx={{}}>
                                {' '}
                                <Stack
                                  align="center"
                                  aria-describedby={idBuyer}
                                  id={idBuyer}
                                >
                                  <Box
                                    component={'div'}
                                    sx={{ mt: '12px' }}
                                    onClick={(event) =>
                                      buyerReadiness(
                                        event,
                                        row?.buyerDetails?.rediness,
                                        row?.buyerDetails?.user?.userName,
                                        row?.buyerDetails?.user?.userSurName
                                      )
                                    }
                                  >
                                    <LinearProgressBarWithPercentage
                                      id={idBuyer}
                                      value={row?.buyerDetails?.rediness}
                                      rediness={row?.buyerDetails?.rediness}
                                    />
                                  </Box>
                                </Stack>
                              </Stack>
                            </Box>
                          </Stack>
                        )}
                        <Stack
                          direction={'column'}
                          sx={{ width: '15%' }}
                          spacing={1}
                        >
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '10px',
                              textAlign: 'center',
                              color: '#666666',
                            }}
                          >
                            Exp
                          </Typography>
                          {row?.buyerDetails?.exp ? (
                            <Typography
                              id={idExp}
                              display="flex"
                              alignItems="center"
                              textAlign="left"
                              onClick={(event) =>
                                buyerExp(
                                  event,
                                  row?.buyerDetails?.user?.userName,
                                  row?.buyerDetails?.exp,
                                  row?.buyerDetails?.user?.userSurName
                                )
                              }
                              sx={{
                                cursor: 'pointer',
                                marginTop: '15px !important',
                              }}
                            >
                              <ExpIcon />
                              <Typography
                                style={{
                                  width: '19.13px',
                                  height: '19.13px',
                                  backgroundColor: '#F64646',
                                  borderRadius: '50%',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  color: '#FFFFFF',
                                  fontFamily: 'Poppins',
                                  fontSize: '12.92px',
                                }}
                              >
                                {row?.buyerDetails?.exp}
                              </Typography>
                            </Typography>
                          ) : (
                            <Typography
                              textAlign={'center'}
                              mt={'18px !important'}
                            >
                              {'-'}
                            </Typography>
                          )}
                        </Stack>
                        <Stack
                          direction={'column'}
                          sx={{ width: '15%' }}
                          spacing={1}
                        >
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '10px',
                              textAlign: 'center',
                              color: '#666666',
                            }}
                          >
                            Profile
                          </Typography>
                          <Stack
                            direction={'row'}
                            alignItems={'center'}
                            justifyContent={'center'}
                          >
                            {row?.buyerDetails?.profile != '' ? (
                              <>
                                <Typography
                                  component="div"
                                  id={idProperty}
                                  onClick={(event) =>
                                    buyerProfile(
                                      event,
                                      row?.buyerDetails?.user?.userName,
                                      row?.buyerDetails?.profile,
                                      row?.buyerDetails?.user?.userSurName
                                    )
                                  }
                                  sx={{
                                    ...poppins400,
                                    fontSize: '13px',
                                    marginRight: '10px',
                                    fontWeight: 400,
                                    cursor: 'pointer',
                                    color: '#112347',
                                    textAlign: 'center',
                                    marginTop: '10px',
                                  }}
                                >
                                  {row?.buyerDetails?.profile}
                                </Typography>
                              </>
                            ) : (
                              <Typography textAlign={'center'} mt={'10px'}>
                                {'-'}
                              </Typography>
                            )}
                          </Stack>
                        </Stack>
                        <Stack
                          direction={'column'}
                          sx={{ width: '10%' }}
                          spacing={1}
                        >
                          <Typography
                            sx={{
                              ...poppins400,
                              fontSize: '10px',
                              textAlign: 'right',
                              color: '#666666',
                            }}
                          >
                            Rating
                          </Typography>
                          <Typography
                            id={idProperty}
                            component="div"
                            onClick={(event) =>
                              propertyProgress(
                                row?.buyerDetails?.interestedAvg,
                                row?.buyerDetails?.rating,
                                event,
                                row?.buyerDetails?.user?.userName,
                                row?.buyerDetails?.user?.userSurName
                              )
                            }
                            sx={displayFlex}
                            style={{
                              justifyContent: 'center',
                              position: 'relative',
                              alignItems: 'center',
                              cursor: 'pointer',
                            }}
                          >
                            <CircularProgressWithLabel
                              value={row?.buyerDetails?.interestedAvg}
                              rating={row?.buyerDetails?.rating}
                            />
                            <CircularProgress
                              value={100}
                              variant="determinate"
                              sx={{
                                position: 'absolute',
                                color: '#C4C4C461',
                                ...poppins500,
                                fontSize: '14px',
                              }}
                              thickness={5}
                              size={40}
                            />
                          </Typography>
                        </Stack>
                      </CardContent>
                    </Card>
                    <Card
                      variant="outlined"
                      sx={{ marginTop: '10px', borderRadius: '8px' }}
                    >
                      <CardContent
                        sx={{
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'space-between',
                        }}
                      >
                        <Stack
                          direction={'row'}
                          spacing={2}
                          justifyContent={'space-between'}
                        >
                          {' '}
                          {!buyeroffer && !StageTwo && (
                            <Stack
                              direction={'column'}
                              sx={{ width: '40%' }}
                              spacing={1}
                              justifyContent={'space-between'}
                            >
                              <Typography
                                sx={{
                                  ...poppins400,
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Status
                              </Typography>
                              <Stack
                                direction={'row'}
                                alignItems={'center'}
                                justifyContent={'center'}
                                onClick={() => {
                                  setManageofferrow(row);
                                  setManageOffer(true);
                                  setisVendorHistoryId(true);
                                }}
                                sx={{ cursor: 'pointer' }}
                              >
                                {row?.buyerOfferDetails != '' ? (
                                  <>
                                    <Grid
                                      container
                                      sx={{
                                        dsiplay: 'flex',
                                        flexDirection: 'column',
                                        gap: '15px',
                                      }}
                                    >
                                      <Grid item>
                                        <div>
                                          <BadgeButton
                                            row={row}
                                            offerStatus={
                                              row?.buyerOfferDetails
                                                ?.offerStatus
                                            }
                                            offerStatusVendor={
                                              row?.buyerOfferDetails
                                                ?.offerStatusVendor
                                            }
                                            isnew={
                                              row?.buyerOfferDetails?.isNew
                                            }
                                            matchessm={matchessm}
                                          />
                                        </div>
                                      </Grid>
                                      {!row?.buyerOfferDetails
                                        ?.offerStatusVendor ||
                                        (row?.buyerOfferDetails
                                          ?.offerStatusVendor != null && (
                                          <Grid item>
                                            <Typography
                                              sx={{
                                                padding: '3px 10px',
                                                border: `1px solid ${getColor(
                                                  row?.buyerOfferDetails
                                                    ?.offerStatusVendor
                                                )}`,
                                                borderRadius: '17px',
                                                width: '125px',
                                                flexWrap: 'nowrap',
                                                whiteSpace: 'nowrap',
                                                fontFamily:
                                                  'Poppins !important',
                                                fontStyle: 'normal !important',
                                                fontWeight: '300 !important',
                                                fontSize: '12px !important',
                                                color: getColor(
                                                  row?.buyerOfferDetails
                                                    ?.offerStatusVendor
                                                ),
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                display: 'flex',
                                                gap: 0.5,
                                              }}
                                            >
                                              <WarningLite
                                                color={getColor(
                                                  row?.buyerOfferDetails
                                                    ?.offerStatusVendor
                                                )}
                                              />
                                              {
                                                row?.buyerOfferDetails
                                                  ?.offerStatusVendor
                                              }
                                            </Typography>
                                          </Grid>
                                        ))}
                                    </Grid>
                                  </>
                                ) : (
                                  <Grid item sx={{ width: '100%' }}>
                                    <Typography textAlign={'left'}>
                                      {'-'}
                                    </Typography>
                                  </Grid>
                                )}
                              </Stack>
                            </Stack>
                          )}
                          <Stack
                            direction={'column'}
                            sx={{ width: '25%' }}
                            justifyContent={'space-between'}
                            spacing={1}
                          >
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize: '10px',
                                color: '#666666',
                              }}
                            >
                              Offer
                            </Typography>
                            {
                              <OfferContainer
                                row={row}
                                data={row?.buyerOfferDetails?.offerPrice}
                                agentReg={true}
                                offerIsFinal={
                                  row?.buyerOfferDetails?.offerIsFinal
                                }
                                userTypeValue={userTypeValue}
                                isMarket={row?.buyerOfferDetails?.isMarket}
                              />
                            }
                          </Stack>
                          <Stack
                            direction={'column'}
                            sx={{ width: '10%' }}
                            spacing={1}
                          >
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize: '10px',
                                color: '#666666',
                              }}
                            >
                              Offers
                            </Typography>
                            <Typography
                              sx={{
                                ...poppins400,
                                fontSize: '12px',
                                textAlign: 'center',
                              }}
                            >
                              {row?.buyerDetails?.noOfOffers}
                            </Typography>
                          </Stack>
                        </Stack>{' '}
                        {!vendorside && (
                          <>
                            <Stack
                              direction={'column'}
                              spacing={1}
                              sx={{ margingBottom: '10px', marginTop: '20px' }}
                            >
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins',
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Offer Terms
                              </Typography>
                              <Grid container spacing={1}>
                                {row?.buyerOfferDetails?.conditionalTerms
                                  ?.length > 0 &&
                                  row.buyerOfferDetails.conditionalTerms.map(
                                    (item) => (
                                      <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        md={3}
                                        lg={3}
                                        key={item.conditionSubjectCode}
                                      >
                                        <Card
                                          variant="outlined"
                                          sx={{
                                            fontFamily: 'Poppins',
                                            borderColor: '#6C2AD2',
                                            borderRadius: '8px',
                                            width: '100%', // Let the grid determine the width
                                            height: matchessm
                                              ? '80px'
                                              : '110px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexDirection: 'column',
                                            justifyContent: 'space-evenly',
                                          }}
                                        >
                                          <Box marginTop="5px">
                                            {item.conditionSubjectCode ===
                                            'SubtoDep001' ? (
                                              <Typography
                                                sx={{
                                                  fontSize: '20px',
                                                  fontFamily: 'Poppins',
                                                }}
                                              >
                                                {item.conditionSubjectFile}%
                                              </Typography>
                                            ) : item.conditionSubjectCode ===
                                              'SubtoSettle001' ? (
                                              <Typography
                                                sx={{
                                                  fontSize: '20px',
                                                  fontFamily: 'Poppins',
                                                }}
                                              >
                                                {item.conditionSubjectFile}
                                              </Typography>
                                            ) : (
                                              <img
                                                src={item.conditionSubjectFile}
                                                alt="file"
                                                width="20"
                                                height="25"
                                              />
                                            )}
                                          </Box>
                                          <Typography
                                            sx={{
                                              whiteSpace: 'wrap',
                                              fontSize: '10px',
                                              width: matchessm
                                                ? '96%'
                                                : '110px',
                                              textAlign: 'center',
                                              fontFamily: 'Poppins',
                                            }}
                                          >
                                            {item.conditionSubjectValue}
                                          </Typography>
                                        </Card>
                                      </Grid>
                                    )
                                  )}
                              </Grid>
                            </Stack>
                            <Stack direction={'column'} spacing={1} mt={'20px'}>
                              <Typography
                                sx={{
                                  fontFamily: 'Poppins',
                                  fontSize: '10px',
                                  color: '#666666',
                                }}
                              >
                                Detailed Status
                              </Typography>
                              <Stack direction={'row'} spacing={2}>
                                <EyeIcon
                                  color={row?.logInsData ? '#6C2AD2' : '666666'}
                                />
                                <Todo
                                  color={
                                    row?.logDueData ? '#6C2AD2' : '#666666'
                                  }
                                />
                                <File
                                  color={
                                    row?.logConData ? '#6C2AD2' : '#666666'
                                  }
                                />
                                <FileCopy
                                  color={
                                    row?.logRevData ? '#6C2AD2' : '#666666'
                                  }
                                />
                                <Downloaded
                                  color={row?.logWData ? '#6C2AD2' : '#666666'}
                                />
                                {row?.logSignData ? (
                                  <SignContract color="#6C2AD2" />
                                ) : (
                                  <SignContract color="#666666" />
                                )}
                                {row?.logDepPayData ? (
                                  <DepositIconColor />
                                ) : (
                                  <DepositIcon />
                                )}
                              </Stack>
                            </Stack>
                          </>
                        )}
                      </CardContent>
                    </Card>
                    {!vendorside && (
                      <Card
                        variant="outlined"
                        sx={{
                          marginTop: '10px',
                          borderRadius: '8px',
                        }}
                      >
                        <CardContent
                          sx={{ padding: '10px', paddingLeft: '20px' }}
                        >
                          {!vendorside && (
                            <>
                              <Stack
                                direction={'column'}
                                justifyContent={'space-between'}
                              >
                                <Stack
                                  direction={'row'}
                                  spacing={2}
                                  justifyContent={'space-between'}
                                  alignItems={'center'}
                                >
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <LinkPartner />
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontSize: '14px',
                                        paddingLeft: '10px',
                                        color: '#666666',
                                      }}
                                    >
                                      Linked Partner
                                    </Typography>
                                  </Box>
                                  <Box
                                    sx={{
                                      widh: '32px',
                                      height: '32px',
                                      backgroundColor: '#BCBBBC1A',
                                      borderRadius: '5px',
                                    }}
                                  >
                                    <PlusIcon />
                                  </Box>
                                </Stack>
                                <Stack
                                  direction={'row'}
                                  alignItems={'center'}
                                  spacing={2}
                                >
                                  <Typography
                                    sx={displayFlex}
                                    style={{
                                      justifyContent: 'center',
                                      position: 'relative',
                                      alignItems: 'center',
                                      paddingRight: '10px',
                                    }}
                                  >
                                    <CircularProgressWithProfile
                                      value={row?.buyerDetails?.profileActivity}
                                      profileImage={
                                        row?.buyerDetails?.user?.userProfile
                                      }
                                      name={
                                        row?.buyerDetails?.user?.userName.charAt(
                                          0
                                        ) +
                                        row?.buyerDetails?.user?.userSurName.charAt(
                                          0
                                        )
                                      }
                                    />
                                  </Typography>

                                  <Stack
                                    direction={'column'}
                                    justifyItems={'center'}
                                    alignItems={'center'}
                                    pt={'20px'}
                                  >
                                    <Typography
                                      sx={{
                                        fontFamily: 'Poppins',
                                        fontWeight: '400',
                                        fontSize: '12px',
                                        whiteSpace: 'nowrap',
                                      }}
                                    >
                                      {`${row?.buyerDetails?.user?.userName} ${row?.buyerDetails?.user?.userSurName}`}
                                    </Typography>
                                    <Stack
                                      direction={'row'}
                                      spacing={2}
                                      justifyContent={'left'}
                                      alignItems={'center'}
                                      width={'100%'}
                                      mt={'10px'}
                                    >
                                      <Avatar
                                        alt=""
                                        src={BlueTick}
                                        sx={{ height: '21px', width: '21px' }}
                                      />
                                      <Avatar
                                        alt=""
                                        src={Monetize}
                                        sx={{ height: '21px', width: '21px' }}
                                      />
                                    </Stack>
                                  </Stack>
                                  <Contact
                                    row={row?.buyerDetails}
                                    directcomm={directcomm}
                                    index={null}
                                  />
                                </Stack>
                              </Stack>
                              <Stack
                                direction={'column'}
                                justifyContent={'space-between'}
                                mt={2.5}
                              >
                                <Stack direction={'row'} alignItems={'center'}>
                                  <LegalIcon
                                    key={index}
                                    uniqueId={`icon-${index}`}
                                  />
                                  <Typography
                                    sx={{
                                      fontFamily: 'Poppins',
                                      fontSize: '14px',
                                      paddingLeft: '10px',
                                      color: '#666666',
                                    }}
                                  >
                                    Legal Representative
                                  </Typography>
                                </Stack>

                                <Grid md={2.5}>
                                  {row?.buyerDetails?.solicitorDetails?.length >
                                  0 ? (
                                    row?.buyerDetails?.solicitorDetails?.map(
                                      (solicitor, index) => (
                                        <Stack
                                          key={index}
                                          direction={'row'}
                                          alignItems={'center'}
                                          spacing={2}
                                          p={2}
                                        >
                                          <Typography
                                            sx={displayFlex}
                                            style={{
                                              justifyContent: 'center',
                                              position: 'relative',
                                              alignItems: 'center',
                                              paddingRight: '10px',
                                            }}
                                          >
                                            <CircularProgressWithProfile
                                              profileImage={
                                                solicitor?.profileImage
                                              }
                                              name={
                                                solicitor?.bsName
                                                  ?.charAt(0)
                                                  ?.toUpperCase() +
                                                solicitor?.bsSurname
                                                  ?.charAt(0)
                                                  ?.toUpperCase()
                                              }
                                            />
                                          </Typography>

                                          <Typography
                                            sx={{
                                              fontFamily: 'Poppins',
                                              fontWeight: '400',
                                              fontSize: '12px',
                                              whiteSpace: 'nowrap',
                                            }}
                                          >
                                            {`${solicitor?.bsName} ${solicitor?.bsSurname}`}
                                          </Typography>

                                          <Contact
                                            row={{
                                              ...row?.buyerDetails
                                                ?.solicitorDetails?.[0],
                                              solicitorDetails: solicitor,
                                            }}
                                            directcomm={directcomm}
                                            index={index}
                                            ExpandedBuyerRegister={true}
                                            propertyDetails={propertyDetails}
                                            userDetail={userDetail}
                                            onShowChat={onShowChat}
                                          />
                                        </Stack>
                                      )
                                    )
                                  ) : (
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        width: '100%',
                                        p: 2,
                                        pr: 2,
                                      }}
                                    >
                                      <Typography
                                        sx={{
                                          fontFamily: 'Poppins',
                                          fontWeight: 500,
                                          fontSize: '12px',
                                        }}
                                      >
                                        -
                                      </Typography>
                                    </Box>
                                  )}
                                </Grid>
                              </Stack>
                            </>
                          )}
                        </CardContent>
                      </Card>
                    )}
                  </AccordionDetails>
                  <Divider />
                </Accordion>
                {(manageOffer || openhistorydialog) && (
                  <ManageOffer
                    offerUniqueId={
                      manageofferrow?.buyerOfferDetails?.offerUniqueId
                    }
                    buyerId={
                      manageofferrow?.buyerOfferDetails?.propertyOfferBuyerId
                    }
                    open={manageOffer}
                    onClose={manageOfferClickClose}
                    manageOffer={manageOffer}
                    setManageOffer={setManageOffer}
                    setOpenhistorydialog={setOpenhistorydialog}
                    getListInfo={getListInfo}
                    updatefunc={updatefunc}
                    offerIsFinal={
                      manageofferrow?.buyerOfferDetails?.offerIsFinal
                    }
                    agentSubText={true}
                    row={manageofferrow}
                    userTypeValue={userTypeValue}
                    badgebtnManageOffer={true}
                    isVendorHistoryId={isVendorHistoryId}
                    tableData={tableData}
                    setisVendorHistoryId={setisVendorHistoryId}
                    onShowChat={onShowChat}
                    vendorDatas={vendorDatas}
                    setIsSwalOpen={setIsSwalOpen}
                    setVendorGeneratePdf={setVendorGeneratePdf}
                  />
                )}
              </>
            );
          }
        })
      ) : (
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'center',
            marging: '10px',
            fontFamily: 'poppins',
            fontSize: matchessm ? '14px' : '16px',
            fontWeight: '500',
            color: '#585858',
          }}
        >
          Buyer Not Available
        </Typography>
      )}
    </Stack>
  );
};

export default TableAccordion;
